<template>
  <div class="content" v-loading.fullscreen.lock="loading">
    <!-- <base-header class="pb-6">
      <div class="row align-items-center py-2">
        <div class="col-lg-6 col-7"></div>
      </div>
    </base-header> -->
    <div class="create-course-wrap">
      <card>
        <!-- Card header -->
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h2 class="mb-0">Create New Course</h2>
          <base-button type="primary" @click="openGenerateAIModal">
            <i class="" aria-hidden="true"></i> Generate with AI
          </base-button>
        </div>
        <!-- FORM SECTION -->
        <div v-if="generateAIModal" class="modal-backdrop" @click.self="closeGenerateAIModal">
          <div class="modal-content">
            <button
              type="button"
              class="close"
              @click="closeGenerateAIModal"
              data-dismiss="modal"
              aria-label="Close"
              style="position: absolute; top: 10px; right: 15px; font-size: 24px; border: none; background: none;"
            >
              <span :aria-hidden="!show">×</span>
            </button>
            <h3>Generate Course Content with AI</h3>
            <form v-if="!showResultsOnly" @submit.prevent="generateCourse">
              <div>
                <label>Course Name</label>
                <input
                  type="text"
                  v-model="aiForm.name"
                  @blur="onCourseNameBlur"
                  placeholder="Enter course name"
                  required
                />
              </div>
              <div>
                <label>Course Length (minutes)</label>
                <input placeholder="Enter course length" type="number" v-model.number="aiForm.length" required max="999" @input="limitCourseLength" />
              </div>
              <div class="custom-select-container">
                <label>Education Level</label>
                <el-select class="select-primary w-100" v-model="aiForm.level" placeholder="Select Level" popper-class="modal-select-dropdown">
                  <el-option class="select-primary w-100" v-for="item in educationLevels" :key="item"
                    :label="item" :value="item">
                  </el-option>
                </el-select>
              </div>
              <div>
                <label>Course Description</label>
                <textarea
                  v-model="aiForm.description"
                  :readonly="loadingDescription"
                  :placeholder="loadingDescription ? 'Generating description...' : 'Enter course description'"
                  required
                ></textarea>

                <!-- Inline Spinner Inside Field (optional) -->
                <span
                  v-if="loadingDescription"
                  style="position: absolute; top: 40px; right: 12px; color: #999;"
                >
                  <i class="fa fa-spinner fa-spin"></i>
                </span>
              </div>
              <div>
                <label>Industry Focus</label>
                <input
                  v-model="aiForm.industry"
                  placeholder="e.g., Hospitality, Healthcare"
                  required
                  type="text"
                />
              </div>
              <div class="checkbox-row">
                <label style="display: flex; align-items: center; gap: 1rem; font-weight: 600;">
                  <span>State Specific?</span>
                  <input type="checkbox" v-model="aiForm.stateSpecific" style="margin-top: 0.1rem;" />
                </label>
              </div>
              <div v-if="aiForm.stateSpecific">
                <label>What State(s)?</label>
                <input type="text" v-model="aiForm.states" placeholder="e.g., Florida, Texas" />
              </div>
              <div>
                <label>Languages</label>
                <input type="text" v-model="aiForm.languages" placeholder="Languages other than english" />
              </div>
              <div>
                <label>Number of Questions</label>
                <input
                  type="number"
                  v-model.number="aiForm.questionCount"
                  min="1"
                  max="99"
                  placeholder="Default: 5"
                  @input="limitQuestionCount"
                />
              </div>
              <div class="custom-select-container" style="margin-bottom: 2rem;" @click="toggleToneDropdown">
                <label class="form-control-label">Preferred Tone</label>
                <el-select class="select-primary w-100" v-model="aiForm.tone" placeholder="Select Tone" popper-class="modal-select-dropdown">
                  <el-option class="select-primary w-100" v-for="item in toneOptions" :key="item"
                    :label="item" :value="item">
                  </el-option>
                </el-select>
              </div>
              <div>
                <label>Learning Objectives (optional)</label>
                <textarea v-model="aiForm.objectives" placeholder="What should learners achieve?"></textarea>
              </div>
              <div style="margin-bottom: 1rem;">
                <label class="block-label">Type of Questions</label>
                <div class="question-types-grid">
                  <div class="question-type-row" v-for="type in questionTypeOptions" :key="type">
                    <span class="question-type-text">{{ type }}</span>
                    <input
                      type="checkbox"
                      :value="type"
                      v-model="aiForm.questionTypes"
                      class="question-checkbox"
                    />
                  </div>
                </div>
              </div>

              <div class="custom-select-container" style="margin-bottom: 2rem;" @click="toggleUploadOwnMediaDropdown">
                <label class="form-control-label">Upload your brand media?</label>
                <el-select class="select-primary w-100" v-model="aiForm.uploadOwnMedia" placeholder="Select Option" popper-class="modal-select-dropdown">
                  <el-option class="select-primary w-100" v-for="item in uploadOwnMediaOptions" :key="item"
                    :label="item" :value="item">
                  </el-option>
                </el-select>
              </div>

              <div v-if="aiForm.uploadOwnMedia === 'Yes'" style="width: 100%; max-width: 100%;">
                <label class="form-control-label" style="font-weight: 600;">Upload Brand Media</label>
                <file-input v-on:change="handleBrandMediaUpload" accept=".jpg,.jpeg,.png,.webp"></file-input>
                <small class="upload-help">Accepted formats: JPG, JPEG, PNG, WEBP — Max size: 5MB per file</small>
              </div>

              <div class="mt-3">
                <base-button type="primary" native-type="submit" :disabled="loadingAI">
                  <span v-if="loadingAI">
                    <i class="fa fa-spinner fa-spin"></i> Generating...
                  </span>
                  <span v-else>Generate</span>
                </base-button>
                <base-button class="greybtn px-4 mr-1 mr-sm-3 " @click="closeGenerateAIModal">Cancel</base-button>
              </div>
            </form>
            <!-- RESULTS SECTION -->
            <div v-if="showResultsOnly">
              <h4>🤖 AI-Generated Course</h4>
              <div class="scroll-box" v-if="generatedContent">
                <textarea
                  v-model="editableCourseText"
                  class="editable-textarea"
                  v-auto-resize
                  rows="30"
                  @input="handleEditedText"
                ></textarea>
              </div>
              <!-- Attachment indicator -->
              <div v-if="aiForm.uploadedMediaFiles && aiForm.uploadedMediaFiles.length" class="attachment-info">
                📎 {{ aiForm.uploadedMediaFiles.length }} attachment{{ aiForm.uploadedMediaFiles.length > 1 ? 's' : '' }} uploaded
              </div>

              <!-- ADVANCED OPTIONS -->
              <div class="advanced-options" style="margin-top: 2rem;">
                <h5>Any suggestions?</h5>

                <input
                  ref="revisionInput"
                  v-model="aiForm.revisionPrompt"
                  placeholder="Add suggestions"
                  type="text"
                />

                <!-- Suggestion Buttons (generated or static for now) -->
                <div class="suggestion-buttons" style="display: flex; gap: 1rem; flex-wrap: wrap; margin-bottom: 1rem;">
                  <button class="suggestion" @click="setRevision('Add lesson:')">+ Add lesson</button>
                  <button class="suggestion" @click="setRevision('Remove lesson:')">+ Remove lesson</button>
                  <button class="suggestion" @click="setRevision('Change focus:')">+ Change focus</button>
                  <button class="suggestion" @click="setRevision('Reorder lessons:')">+ Reorder lessons</button>
                </div>

                <div class="modal-actions" style="display: flex; justify-content: space-between; gap: 1rem; width: 100%;">
                  <!-- Left-aligned back button -->
                  <div>
                    <base-button type="secondary" @click="backToPreviousStep">
                      Back
                    </base-button>
                  </div>

                  <!-- Right-aligned regenerate & submit -->
                  <div>
                    <base-button
                      type="primary"
                      class="mr-1 mr-sm-3"
                      @click="generateCourse"
                      :disabled="loadingAI"
                    >
                      <span v-if="loadingAI">🔄 Regenerating...</span>
                      <span v-else>Regenerate</span>
                    </base-button>

                    <base-button
                      type="primary"
                      @click="submitAICourse"
                      :disabled="loadingAI"
                    >
                      Submit
                    </base-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Course Generating Overlay with Progress Bar -->
        <div v-if="loadingAI" class="loading-overlay">
          <div class="loading-box">
            <button
              type="button"
              class="close"
              @click="closeGenerateAIModal"
              data-dismiss="modal"
              aria-label="Close"
              style="position: absolute; top: 10px; right: 15px; font-size: 24px; border: none; background: none;"
            >
              <span :aria-hidden="!show">×</span>
            </button>
            <p style="margin-bottom: 1rem; text-align: center;">
              {{ loadingMessage }}
            </p>
            <div class="progress-bar-container">
              <div class="progress-bar-fill" :style="{ width: progress + '%' }"></div>
            </div>
          </div>
        </div>

        <!-- Course type overlay -->
          <div v-if="showCourseTypeModal" class="modal-backdrop">
            <div class="modal-box">
              <button
                type="button"
                class="close"
                @click="closeGenerateAIModal"
                data-dismiss="modal"
                aria-label="Close"
                style="position: absolute; top: 5px; right: 5px; font-size: 24px; border: none; background: none;"
              >
                <span :aria-hidden="!show">×</span>
              </button>
              <h3>Select Course Type</h3>
              <div class="custom-select-container" style="margin-bottom: 1rem;" @click="toggleCourseTypeDropdown">
                <label class="form-control-label">Choose the format for this course:</label>
                <el-select class="select-primary w-100" v-model="aiForm.courseType" placeholder="Select Course Type" popper-class="modal-select-dropdown">
                  <el-option class="select-primary w-100" v-for="item in courseTypeOptions" :key="item"
                    :label="item" :value="item">
                  </el-option>
                </el-select>

              </div>

              <div class="modal-actions" style="margin-top: 1.5rem; display: flex; justify-content: space-between; gap: 1rem;">
                <!-- Back button on the left -->
                <base-button type="secondary" @click="backFromCourseType">
                  Back
                </base-button>

                <!-- Confirm button on the right -->
                <base-button type="primary" @click="confirmCourseType">
                  Confirm
                </base-button>
              </div>
            </div>
          </div>

        <!-- PDF loading bar -->
        <transition name="fade">
          <div v-if="showPDFLoading" class="loading-overlay">
            <div class="loading-box">
              <p class="loading-message">
                Generating a PDF preview of your course. This might take a few seconds depending on the content length.
              </p>
              <div class="progress-bar-container">
                <div class="progress-bar-fill" :style="{ width: progress + '%' }"></div>
              </div>
            </div>
          </div>
        </transition>

        <transition name="fade">
          <div class="success-modal" v-if="showSuccessModal">
            <div class="success-content">
              <h4>✅ Course Submitted!</h4>
              <p style="text-align: center;">{{ editor == "super-admin" ? "Course have been sent by email and fields have been prefilled." : submitMessage }}</p>
              <base-button class="greybtn px-4 mr-1 mr-sm-3" @click="showSuccessModal = false">Close</base-button>
            </div>
          </div>
        </transition>


        <div>
          <div class="form-radio d-flex flex-wrap g-4" style="text-align:right;">
            <div class="userstatus form-inline mb-2 mb-md-0 mr-4" v-if="!hideFieldsFromCompanyAdmin">
              <label class="form-control-label mr-2">Add to Store</label>
              <div class="d-flex justify-content-center">
                <base-switch class="mr-1" type="success" id="live-switch" v-model="course.live"></base-switch>
              </div>
            </div>
            <div class="userstatus form-inline mb-2 mb-md-0 mr-4" v-if="!hideFieldsFromCompanyAdmin">
              <label class="form-control-label mr-2">Popular Course</label>
              <div class="d-flex justify-content-center">
                <base-switch class="mr-1" type="success" id="live-switch" v-model="course.popular"></base-switch>
              </div>
            </div>
            <div class="userstatus form-inline mb-2 mb-md-0 mr-4" v-if="!hideFieldsFromCompanyAdmin">
              <label class="form-control-label mr-2">Hr Basics</label>
              <div class="d-flex justify-content-center">
                <base-switch class="mr-1" type="success" id="live-switch" v-model="course.hrbasics"></base-switch>
              </div>
            </div>
            <div class="userstatus mb-2 mb-md-0 form-inline mr-4">
              <label class="form-control-label mr-2">Status</label>
              <div class="d-flex justify-content-center">
                <base-switch class="mr-1" type="success" id="status-switch" v-model="course.status"></base-switch>
              </div>
            </div>
            <div class="userstatus mb-2 mb-md-0 form-inline mr-4">
              <label class="form-control-label mr-2">For Managers</label>
              <div class="d-flex justify-content-center">
                <base-switch class="mr-1" type="success" v-model="course.formanager"></base-switch>
              </div>
            </div>
            <div class="userstatus mb-2 mb-md-0 form-inline mr-4">
              <label class="form-control-label mr-2">For Employees</label>
              <div class="d-flex justify-content-center">
                <base-switch class="mr-1" type="success" v-model="course.foremployee"></base-switch>
              </div>
            </div>
            <div class="userstatus mb-2 mb-md-0 form-inline mr-4">
              <label class="form-control-label mr-2 ">SCORM</label>
              <div class="d-flex justify-content-end">
                <base-switch class="mr-1" type="success" v-model="course.isScorm"></base-switch>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
          <form class="needs-validation general-form" @submit.prevent="handleSubmit(saveCourse)"
            enctype="multipart/form-data">
            <div class="form-row">
              <div class="col-md-12">
                <div class="form-row">
                  <div class="col-md-4">
                    <base-input name="Course Name" placeholder="Course Name" rules="required"
                      v-model="course.course_name">
                      <template #label>
                      <label>
                        Course Name <span class="requireField">*</span>
                      </label>
                    </template>
                    </base-input>
                  </div>
                  <div class="col-md-4">
                    <base-input  name="Name As Per Certificate" :maxlength="max"
                      placeholder="Course Name As Per Certificate" rules="required"
                      v-model="course.course_name_certificate">
                      <template #label>
                      <label>
                        Course Name On Certificate <span class="requireField">*</span>
                      </label>
                    </template>
                    </base-input>
                  </div>
                  <div class="col-md-4" v-if="!hideFieldsFromCompanyAdmin">
                    <base-input  name="Secondary Course Name"
                      placeholder="Secondary Course Name" rules="required" v-model="course.secondary_course_name">
                      <template #label>
                      <label>
                        Secondary Course Name <span class="requireField">*</span>
                      </label>
                    </template>
                    </base-input>
                  </div>
                  <div class="col-md-4" v-if="!hideFieldsFromCompanyAdmin">
                    <base-input name="Course Length" placeholder="Course Length"
                      type="number" min="1" rules="required" v-model="course.course_length">
                      <template #label>
                      <label>
                        Course Length (mins) <span class="requireField">*</span>
                      </label>
                    </template>
                    </base-input>
                  </div>
                  <div class="col-md-4" v-if="!hideFieldsFromCompanyAdmin">
                    <label class="form-control-label">Course Cost <span class="requireField">*</span></label>
                    <money class="form-control" v-model="course.course_cost" v-bind="money"></money>
                  </div>
                  <div class="col-md-4">
                    <base-input name="Allowed Attempts" type="number" min="1" placeholder="Attempts"
                      v-model="course.allowed_attempts">
                      <template #label>
                      <label>
                        Attempts <span class="requireField">*</span>
                      </label>
                    </template>
                    </base-input>
                  </div>

                  <div class="col-md-4">
                    <label class="form-control-label">Passing Rate</label>
                    <br />
                    <base-input v-model="course.course_pass_rate" value="" type="text"
                      placeholder="Pass Rate"></base-input>
                  </div>
                  <div class="col-md-4">
                    <base-input type="number" min="0" label="Employee Days to Complete" name="Employee Days to Complete:"
                      placeholder="Employee Days to Complete" v-model="course.employees_days_to_complete">
                    </base-input>
                  </div>
                  <div class="col-md-4">
                    <base-input type="number" min="0" label="Managers Days to Complete" name="Managers Days to Complete"
                      placeholder="Managers Days to Complete" v-model="course.manager_days_to_complete">
                    </base-input>
                  </div>

                  <div class="col-md-4">
                    <base-input label="Pass Message" name="Pass Message" placeholder="Pass Message"
                      v-model="course.course_passmessage">
                    </base-input>
                  </div>
                  <div class="col-md-4">
                    <base-input label="Fail Message" name="Fail Message" placeholder="Fail Message"
                      v-model="course.course_failmessage">
                    </base-input>
                  </div>
                  <div class="col-md-4" v-if="!hideFieldsFromCompanyAdmin">
                    <label class="form-control-label">Image</label>
                    <form>
                      <file-input accept="image/png, image/jpeg" v-on:change="onCourseImage"></file-input>
                    </form>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mb-4">
                <label class="form-control-label">Course Instructions <span class="requireField">*</span></label>
                <vue-editor v-model="course.course_description"></vue-editor>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-4">
                <base-input label="Next Course">
                  <el-select filterable placeholder="None" v-model="course.nextcourse">
                    <el-option v-for="option in courses" class="select-primary" :value="option.value"
                      :label="option.label" :key="option.value">
                    </el-option>
                  </el-select>
                </base-input>
              </div>

              <div class="col-md-4">
                <base-input label="Course Classification">
                  <el-select clearable placeholder="Select Classification" v-model="course.classification">
                    <el-option class="select-primary" value="homeowner" label="Homeowner" key="homeowner"></el-option>
                    <el-option class="select-primary" value="professional" label="Professional" key="professional"></el-option>
                  </el-select>
                </base-input>
              </div>

              <div class="col-md-4" v-if="course.nextcourse != '0'">
                <base-input type="number" label="Assignment Gap (Days)" name="Assignment Gap (Days)"
                  placeholder="Assignment Gap" v-model="course.assignment_gap">
                </base-input>
              </div>
              <div class="col-md-4" v-if="!hideFieldsFromCompanyAdmin">
                <base-input label="Company Specific">
                  <el-select filterable placeholder="Select" v-model="course.companyspecific">
                    <el-option v-for="option in company_specific" class="select-primary" :value="option.value"
                      :label="option.label" :key="option.value">
                    </el-option>
                  </el-select>
                </base-input>
              </div>
              <div class="col-md-4" v-if="course.companyspecific">
                <el-popover ref="fromPopOver" placement="top-start" width="250" trigger="hover">
                  <span style="display: flex; justify-content: center;">
                    This Course will Automatically assign to
                    {{ course.companyspecific.label }} Company.
                  </span>
                </el-popover>
                <span>
                  <i v-popover:fromPopOver class="fa fa-info-circle
                    text-blue" />
                </span>
              </div>
              <div class="col-md-4" v-if="!course.companyspecific">
                <base-input label="Assigned Companies" v-if="!hideFieldsFromCompanyAdmin">
                  <el-select filterable multiple placeholder="Select" v-model="course.assigned_companies_id">
                    <el-option v-for="option in companies" class="select-primary" :value="option.value"
                      :label="option.label" :key="option.value">
                    </el-option>
                  </el-select>
                </base-input>
              </div>
            </div>
            <div class="row mt-2" v-if="!hideFieldsFromCompanyAdmin">
              <div class="col-md-3 mb-3 mb-md-0" >
                <label class="chk-style">Compliance Course <input type="checkbox" v-model="course.course_type" /><span
                    class="checkmark"></span></label>

                <!--
                <input type="checkbox" v-model="course.course_type" />
                Compliance Course -->
              </div>
              <div class="col-md-3 mb-3 mb-md-0">
                <label class="chk-style">Factor Authentication <input type="checkbox"
                    v-model="course.course_2fa" /><span class="checkmark"></span></label>
                <!-- <input type="checkbox" v-model="course.course_2fa" /> Require 2
                Factor Authentication -->
              </div>
              <div class="col-md-3 mb-3 mb-md-0">
                <label class="chk-style">Discounted Course <input type="checkbox"
                    v-model="course.discounted_course" /><span class="checkmark"></span></label>
                <!-- <input type="checkbox" v-model="course.discounted_course" /> -->
                <!-- Discounted Course -->
              </div>
              <div class="col-md-3 mb-3 mb-md-0">
                <label class="chk-style">Include Weekly Report <input type="checkbox"
                    v-model="course.weekly_report" /><span class="checkmark"></span></label>
                <!-- <input type="checkbox" v-model="course.weekly_report" />
                Include Weekly Report -->
              </div>
              <div class="col-md-2 mb-3 mb-md-0" v-if="course_id == 123">
                <label class="chk-style">Food Safe Online Proctored Exam <input type="checkbox"
                    v-model="course.food_safe_online_proctored_exam" /><span class="checkmark"></span></label>

                <!-- <input type="checkbox" v-model="course.food_safe_online_proctored_exam" />
                Food Safe Online Proctored Exam -->
              </div>
            </div>
            <div class="row mt-2" v-if="!hideFieldsFromCompanyAdmin">
              <div class="col-md-12" v-if="!course.discounted_course">
                <label class="form-control-label">Discounted Course Comment</label>
                <textarea class="form-control" rows="20" v-model="course.discounted_course_comment"></textarea>
              </div>
            </div>
            <div class="row mt-2" v-if="!hideFieldsFromCompanyAdmin">
              <div class="col-md-3" >
                <label class="chk-style mb-3 mb-md-0">Reassign On Expire <input type="checkbox"
                    v-model="course.reassignment_expiry" /><span class="checkmark"></span></label>

                <!-- <input type="checkbox" v-model="course.reassignment_expiry" />
                Reassign On Expire -->
              </div>
              <div class="col-md-3" v-if="course.reassignment_expiry">
                <base-input type="number" min="0" label="No of attempts before Expiration"
                  name="# of attempts before Expiration" placeholder="" v-model="course.expiry_attempts">
                </base-input>
              </div>
            </div>
            <hr />
            <div class="row mt-2">
              <div class="col-md-12" v-if="!hideFieldsFromCompanyAdmin">
                <h3>Course Resources</h3>
                <base-input label="Resources">
                  <el-select filterable multiple placeholder="Select" v-model="course.courseResources">
                    <el-option v-for="courseResource in courseResources" class="select-primary"
                      :value="courseResource.id" :label="courseResource.name" :key="courseResource.id"></el-option>
                  </el-select>
                </base-input>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-3 border-right">
                <div class="row ">
                  <div class="col-md-12">
                    <h3>Course Lessons</h3>
                  </div>
                </div>
                <div class="row p-1" v-for="(lesson, index) in course.course_lessons" :key="lesson.id">
                  <div class="col-md-12">
                    <span class="cursor"><b v-on:click="openThisLesson(index)"><a class="href">{{ lesson.lesson_name
                          }}</a></b></span>
                    <base-button class="pull-right" type="" size="sm" style="float:right;"
                      @click.prevent="removeLesson(index)">
                      <img class="ico-del" src="/img/icons/common/delete-icon.svg" alt="" />
                      <!-- <i class="fa fa-trash "></i> -->
                    </base-button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <label v-on:click="addLessonClicked()">
                      <i class="fas fa-plus-circle mr-1"></i><b class="add_text">Add Lesson</b>
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-md-3 border-right">
                <div class="row">
                  <div class="col-md-12">
                    <h3>Course Test</h3>
                  </div>
                </div>
                <div class="row" v-for="(test, index) in course.course_test" :key="test.id">
                  <div class="col-md-12">
                    <span><b v-on:click="openThisTest(index)"><a class="href">{{ "Test " + (index + 1) }}</a></b></span>
                    <base-button class="pull-right" type="" size="sm" style="float:right;"
                      @click.prevent="removeTest(index)">
                      <!-- <i class="fa fa-trash"></i> -->
                      <img class="ico-del" src="/img/icons/common/delete-icon.svg" alt="" />
                    </base-button>
                  </div>
                </div>

                <div class="row" v-if="course.course_test.length == 0">
                  <div class="col-md-12">
                    <label class="cursor" v-on:click="addTestClicked()">
                      <i class="fas fa-plus-circle mr-1"></i><b class="add_text">Add Test</b>
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-md-3 border-right">
                <div class="row">
                  <div class="col-md-12">
                    <h3>Pre Test</h3>
                  </div>
                </div>
                <div class="row" v-for="(pretest, index) in course.course_pretest" :key="pretest.id">
                  <div class="col-md-12">
                    <span><b v-on:click="openThisPreTest(index)"><a class="href">{{ pretest.name }}</a></b></span>
                    <base-button class="pull-right" type="" size="sm" style="float:right;"
                      @click.prevent="removePreTest(index)">
                      <!-- <i class="fa fa-trash"></i> -->
                      <img class="ico-del" src="/img/icons/common/delete-icon.svg" alt="" />
                    </base-button>
                  </div>
                </div>

                <div class="row" v-if="course.course_pretest == 0">
                  <div class="col-md-12">
                    <label class="cursor" v-on:click="addPreTestClicked()">
                      <i class="fas fa-plus-circle mr-1"></i><b class="add_text">Add Pre Test</b>
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-md-3 border-right">
                <div class="row">
                  <div class="col-md-12">
                    <h3>Survey Test</h3>
                  </div>
                </div>
                <div class="row" v-for="(surveytest, index) in course.course_surveytest" :key="surveytest.id">
                  <div class="col-md-12">
                    <span><b v-on:click="openThisSurveyTest(index)"><a class="href">{{ surveytest.name }}</a></b></span>
                    <base-button class="pull-right" type="" size="sm" style="float:right;"
                      @click.prevent="removeSurveyTest(index)">
                      <!-- <i class="fa fa-trash"></i> -->
                      <img class="ico-del" src="/img/icons/common/delete-icon.svg" alt="" />
                    </base-button>
                  </div>
                </div>

                <div class="row" v-if="course.course_surveytest == 0">
                  <div class="col-md-12">
                    <label class="cursor" v-on:click="addSurveyTestClicked()">
                      <i class="fas fa-plus-circle mr-1"></i><b class="add_text">Add Survey Test</b>
                    </label>
                  </div>
                  <el-select placeholder="Select Survey" filterable class="ml-2 mr-2" rules="required"
                    v-model="course.course_survey">
                    <el-option v-for="option in surveyData" class="select-primary mr-3" :value="option.id"
                      :label="option.survey_name" :key="option.id">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <hr />
            <div class="row form-radio mb-4">

              <div class="userstatus col-md-3 mb-3 mb-md-0 form-inline ">
                <label class="form-control-label mr-2 ">Allow Certificate</label>
                <div class="d-flex justify-content-center">
                  <base-switch class="mr-1" type="success" v-model="course.certificateavilable"></base-switch>
                </div>
              </div>

              <div class="col-md-4 form-inline" v-if="course.certificateavilable">
                <el-select placeholder="Select Certificate" filterable class="mt-3 w-100" rules="required"
                  v-model="course.course_certificate">
                  <el-option v-for="option in  certificate_Data" class="select-primary mr-3" :value="option.id"
                    :label="option.certificate_name" :key="option.id">
                  </el-option>
                </el-select>
              </div>
              <div class="col-md-5">
                <base-input label="Certificate Valid For (Days)" name="Certificate Valid For (Days)"
                  placeholder="Certificate Validity" v-model.number="course.certificate_validity"
                    @input="validateNumberInput"
                  >
                </base-input>
              </div>

              <div class="col-md-5" v-if="course.isScorm">
                <div class="mt-2">
                  <h3 class="d-block mb-1">SCORM Version</h3>

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="scorm12"
                      name="scorm_version"
                      value="1"
                      v-model="course.scorm_version"
                    />
                    <label class="form-check-label" for="scorm_version">SCORM 1.2</label>
                  </div>

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="scorm2004"
                      name="scorm_version"
                      value="2"
                      v-model="course.scorm_version"
                    />
                    <label class="form-check-label" for="scorm_version">SCORM 2004</label>
                  </div>
                </div>
                <base-input label="SCORM File:">
                    <input class="form-control" type="file" accept=".zip" v-on:change="handleScromFile($event)" />
                </base-input>
                <br>
                <el-progress
                v-if="showProgress"
                :percentage="progress"
                :stroke-width="10"
                :text-inside="true"
                status="success"
                class="mb-4 progress-bar-wrap"
              ></el-progress>
              </div>
            </div>

            <div class="text-right">
              <base-button class="greybtn px-4 mr-1 mr-sm-3 " @click="$router.go(-1)">Cancel
              </base-button>
              <base-button type="primary" class="px-4" @click.prevent="saveCourse">
                {{ "Submit" }}
              </base-button>
            </div>
          </form>
        </validation-observer>
        <!--            lesson modal-->
        <modal :show.sync="lessonModal" class="user-modal">
          <h4 slot="header" class="modal-title mb-0" style="color: #272C33;" v-if="!lesson_preview">
            Add New Lesson
          </h4>
          <h4 slot="header" class="modal-title mb-0" style="color: #272C33;" v-if="lesson_preview">
            <small>Course Name:</small> {{ course.course_name }}
          </h4>
          <form v-if="!lesson_preview">
            <div class="row form-radio">
              <div class="col-md-12 text-right mb-3">
                <base-button type="primary" @click.prevent="previewLesson">
                Preview
              </base-button>
                <base-button type="primary" @click.prevent="saveLesson">
                  Save Lesson
                </base-button>
              </div>
              <div class="col-md-2">
                <base-input type="text" label="Lesson Name *" placeholder="Lesson Name" v-model="lesson.lesson_name">
                </base-input>
                <span class="text-danger small" v-if="lesson_save_clicked && lesson.lesson_name === ''">Lesson Name
                  Field
                  is Required!</span>
              </div>
              <div class="col-md-2">
                <label class="form-control-label">Select Type</label>
                <el-select class="select-primary w-100" v-model="lesson.lesson_type" placeholder="Select Type">
                  <el-option class="select-primary w-100" v-for="item in lessontype" :key="item.value"
                    :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="col-md-2" v-if="lesson.lesson_type == 'video'">
                <base-input type="text" label="Video Id" placeholder="Video Id" v-model="lesson.lesson_video_url">
                </base-input>
              </div>
              <div class="col-md-2" v-if="lesson.lesson_type == 'youtube-video'">
                <base-input label="YouTube Id" placeholder="Youtube Id" type="text"
                  v-model="lesson.youtube_lesson_video_url">
                </base-input>
              </div>
              <div class="col-md-2" v-if="lesson.lesson_type == 'pdf'">
                <div class="" v-if="!lesson.lesson_pdf_url">
                  <label>Upload Pdf</label>
                  <file-input v-on:change="onImageChange"></file-input>
                </div>
                <div v-else>
                  <a :href="baseUrl + '/employee/documents/' + lesson.lesson_pdf_url
                    " target="_blank">{{ lesson.lesson_pdf_url }}</a>
                </div>
              </div>
              <div class="col-md-2 userstatus pt-3">
                <label class="form-control-label ">Next Button Timer:</label>
                <div class="d-flex">
                  <base-switch class="mb-1" type="success" id="status-switch"
                    v-model="lesson.nextButtonTimerStatus"></base-switch>
                </div>
              </div>
              <div class="col-md-2" v-if="lesson.nextButtonTimerStatus">
                <label class="form-control-label ">Select Timing:</label>

                <vue-timepicker format="HH:mm:ss" v-model="lesson.timerValue"></vue-timepicker>
              </div>
              <div class="col-md-2 userstatus pt-3">
                <label class="form-control-label ">Lesson Quiz:</label><br />
                <div class="d-flex">
                  <base-switch class="mr-1" type="success" id="status-switch" v-model="lesson.quizStatus"></base-switch>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label class="form-control-label">Lesson Content *</label>
                  <vue-editor placeholder="Lesson Content Here..." v-model="lesson.lesson_content"></vue-editor>
                </div>
              </div>
            </div>

            <div v-if="lesson.quizStatus">
              <div class="row">
                <div class="col-md-4">
                  <base-input type="number" min="1" label="Allowed Attempts" name="Allowed Attempts"
                    placeholder="Allowed Attempts" v-model="lesson.allowed_attempts">
                  </base-input>
                  <span class="text-danger small" v-if="lesson.quizStatus &&
                    lesson_save_clicked &&
                    lesson.allowed_attempts === ''
                  ">Allowed Attempts Field is Required!</span>
                </div>
                <div class="col-md-4">
                  <label class="form-control-label">Passing Rate</label>
                  <base-input v-model="lesson.passing_rate" min="0" max="100" value="" type="text"
                    placeholder="Pass Rate"></base-input>
                </div>
                <div class="col-md-4">
                  <base-input type="number" min="1" label="Number of Questions" placeholder=""
                    v-model="lesson.no_of_questions">
                  </base-input>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="form-control-label">Quiz Instruction: </label>
                    <vue-editor placeholder="Quiz Instructions here..."
                      v-model="lesson.lesson_quiz_instruction"></vue-editor>
                  </div>
                </div>
              </div>
              <div class="brdr question_box mt-3" v-for="(question, q_index) in lesson.lesson_questions"
                :key="question.id">
                <div class="row align-items-center mb-4 form-radio">
                  <div class="col-md-9 d-flex align-items-center">
                    <h4 style=" color: #272C33; margin-bottom:0">Question {{ q_index + 1 }}</h4>
                    <div class="d-flex justify-content-md-end userstatus pl-4"
                      v-on:click="changeStatus(props.$index, props.row)">
                      <base-switch class="mr-1" v-if="question.question_status" type="success"
                        :id="'lessonQuestion-switch_' + q_index" v-model="question.question_status"></base-switch>
                      <base-switch class="mr-1" v-else type="danger" v-model="question.question_status"
                        :id="'lessonQuestion-switch_' + q_index"></base-switch>
                    </div>
                  </div>
                  <div class="col-md-2 col-6">

                  </div>
                  <div class="col-md-1 col-6">
                    <base-button type="" style="float:right;" size="sm" @click.prevent="removeLessonQuestion(q_index)">
                      <!-- <i class="fa fa-trash"></i> -->
                      <img class="ico-del" src="/img/icons/common/delete-icon.svg" alt="" />
                    </base-button>
                  </div>
                </div>
                <div class="row ">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-6">
                        <base-input type="text" label="Question" placeholder="Question"
                          v-model="question.question_text">
                        </base-input>
                        <span class="text-danger small" v-if="lesson.quizStatus &&
                          isRequired &&
                          lesson_save_clicked &&
                          question.question_text === '' &&
                          question.question_status
                        ">Question Field is Required!</span>
                      </div>
                      <div class="col-md-6">
                        <!-- <div class="currest-ans-label">
                          <label class="form-control-label">Correct Answer 2</label>
                        </div> -->
                        <div class="row" v-for="(option, o_index) in question.options" :key="option.id">
                          <div class="col-sm-8 col-7">
                            <base-input type="text" :label="'Answer Option ' + (o_index + 1)" placeholder="Option"
                              v-model="option.option_text">
                            </base-input>
                            <span class="text-danger small" v-if="lesson.quizStatus &&
                              isRequired &&
                              lesson_save_clicked &&
                              option.option_text === '' &&
                              question.question_status
                            ">Option Field is Required!</span>
                          </div>
                          <div class="col-sm-4 col-5">
                            <div class="que-ans-row">
                              <div class="d-flex align-items-center mt-3">
                                <el-checkbox v-model="option.correct">Correct Answer</el-checkbox>
                              </div>
                              <div>
                                <base-button type="" size="sm" style="float:right;" @click.prevent="
                                  removeLessonOption(q_index, o_index)
                                  ">
                                  <!-- <i class="fa fa-trash"></i> -->
                                  <img class="ico-del" src="/img/icons/common/delete-icon.svg" alt="" />
                                </base-button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-7">
                            <label style=" color: #272C33;" class=" cursor" v-on:click="addOptionlesson(q_index)"><b
                                class="mr-1">+</b>Add Another Option</label>
                          </div>
                          <div class="col-md-5 text-center"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label style=" color: #272C33;" class=" cursor" v-on:click="addQuestionlesson()"><b>+</b>Add Another
                    Question</label>
                </div>
              </div>
            </div>
            <div class="text-right">
              <!-- <base-button type="primary" @click.prevent="saveLesson">
                Save Lesson
              </base-button>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <base-button type="primary" @click.prevent="previewLesson">
                Preview
              </base-button> -->
            </div>
            <div class="clearfix"></div>
          </form>
          <div class="container" v-if="lesson_preview">
            <div class="row brdr">
              <div class="col-md-12">
                <p><b>Lesson:</b> {{ lesson.lesson_name }}</p>
                <div v-html="lesson.lesson_content"></div>
                <span v-if="lesson.lesson_questions && lesson.lesson_questions.length > 0">
                  <div  class="row brdr mb" v-for="(question, index) in lesson.lesson_questions" :key="question.id">
                    <div class="col-md-12">
                      <p>
                        <b>Question {{ index + 1 }} </b>
                        {{ question.question_text }}
                      </p>
                      <ul class="list-unstyled ">
                        <li v-for="(option, index) in question.options" :key="option.id">
                          <base-radio :label="'radio_' + index" v-model="question.answer">{{ option.option_text }}
                          </base-radio>
                        </li>
                      </ul>
                    </div>
                  </div>
                </span>
              </div>
            </div>
            <div class="text-right">
              <base-button class="greybtn" @click.prevent="backToLesson">
                Back
              </base-button>
              <base-button type="primary" @click.prevent="saveLesson">
                Save
              </base-button>
            </div>
          </div>
        </modal>
        <!--            end of lesson modal-->
        <!--            test modal-->
        <modal :show.sync="testModal" class="user-modal">
          <h4 v-if="main_test && !test_preview && !test_question" style="color: #444C57;" slot="header"
            class="modal-title mb-0">
            Course Test
          </h4>
          <h4 v-if="!main_test && !test_preview && test_question" style="color: #444C57;" slot="header"
            class="modal-title mb-0">
            Test Question
          </h4>
          <h4 v-if="!main_test && test_preview && !test_question" style="color: #444C57;" slot="header"
            class="modal-title mb-0">
            Test Question Preview
          </h4>
          <form v-if="main_test && !test_preview && !test_question">
            <div class="row">
              <div class="mb-2 col-md-12 text-right">
                <base-button type="primary" @click.prevent="saveTest">
                  Save Test
                </base-button>
                <base-button type="primary" v-on:click="testQuestionClicked()" style="float:right;">
                  <i slot="label" class=" nc-icon nc-cloud-upload-94 mr-2 icon_btn"></i>
                  <span class="">Upload Test Questions</span>
                </base-button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2">
                <el-checkbox v-model="test.practice_test" :active-value="1" :inactive-value="0">
                  Practice test
                </el-checkbox>
              </div>
              <div class="col-md-3" v-if="test.practice_test">
                <div>
                  <base-input label="After # of questions enable submit button" type="number" min="1"
                    v-model="test.enable_submit_button">
                  </base-input>
                </div>
              </div>
              <div class="col-md-2">
                <div>
                  <base-input label="Number of questions" type="number" min="1" v-model="test.test_no_of_questions">
                  </base-input>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-control-label">Pass Message</label>
                  <textarea rows="1" class="form-control border-input" placeholder="Pass Message..."
                    v-model="test.test_pass_message">
                  </textarea>
                  <span class="text-danger small" v-if="test_save_clicked && test.test_pass_message === ''">Pass Message
                    Field is Required!</span>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-control-label">Fail Message</label>
                  <textarea rows="1" class="form-control border-input" placeholder="Fail Message..."
                    v-model="test.test_fail_message">
                  </textarea>
                  <span class="text-danger small" v-if="test_save_clicked && test.test_fail_message === ''">Fail Message
                    Field is Required!</span>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label class="form-control-label">Test Instruction</label>
                  <vue-editor v-model="test.test_instruction"></vue-editor>
                  <span class="text-danger small" v-if="test_save_clicked && test.test_instruction === ''">Test
                    Instruction Field is Required!</span>
                </div>
              </div>
            </div>
            <div class="brdr question_box mt-3" v-for="(question, q_index) in test.test_questions" :key="question.id">
              <div class="row align-items-center mb-4">
                <div class="col-md-9 form-radio d-flex align-items-center ">
                  <h4 style="color: #444C57; margin-bottom: 0;">Question {{ q_index + 1 }}</h4>
                  <div class="d-flex justify-content-md-end userstatus pl-4"
                    v-on:click="changeStatus(props.$index, props.row)">
                    <base-switch class="mr-1" v-if="question.question_status" type="success"
                      :id="'testQuestion-switch_' + q_index" v-model="question.question_status"></base-switch>
                    <base-switch class="mr-1" v-else type="danger" v-model="question.question_status"
                      :id="'testQuestion-switch_' + q_index"></base-switch>
                  </div>
                </div>
                <div class="col-md-2 col-6">

                </div>
                <div class="col-md-1 col-6">
                  <base-button type="" style="float:right;" size="sm" @click.prevent="removeTestQuestion(q_index)">
                    <!-- <i class="fa fa-trash"></i> -->
                    <img class="ico-del" src="/img/icons/common/delete-icon.svg" alt="" />
                  </base-button>
                </div>
              </div>
              <div class="row ">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">
                      <base-input type="text" label="Question" placeholder="Question" v-model="question.question_text">
                      </base-input>
                      <span class="text-danger small" v-if="isRequired &&
                        test_save_clicked &&
                        question.question_text === '' &&
                        question.question_status
                      ">Question Field is Required!</span>
                    </div>
                    <div class="col-md-6">
                      <!-- <div class="currest-ans-label">
                        <label class="form-control-label">Correct Answer</label>
                      </div> -->

                      <div class="row" v-for="(option, o_index) in question.options" :key="option.id">
                        <div class="col-sm-8 col-7">
                          <base-input type="text" :label="'Answer Option ' + (o_index + 1)" placeholder="Option"
                            v-model="option.option_text">
                          </base-input>
                          <span class="text-danger small" v-if="isRequired &&
                            test_save_clicked &&
                            option.option_text === '' &&
                            question.question_status
                          ">Option Field is Required!</span>
                        </div>
                        <div class="col-sm-4  col-5">
                          <div class="que-ans-row">
                            <div class="d-flex align-items-center mt-3">
                              <el-checkbox v-model="option.correct">Correct Answer</el-checkbox>
                            </div>
                            <div>
                              <base-button size="sm" type="" @click.prevent="
                                removeTestOption(q_index, o_index)
                                ">
                                <!-- <i class="fa fa-trash"></i> -->
                                <img class="ico-del" src="/img/icons/common/delete-icon.svg" alt="" />
                              </base-button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-7">
                          <label style="color: #444C57;" class=" cursor" v-on:click="addOptionTest(q_index)"><b
                              class="mr-1">+</b>Add Another Option</label>
                        </div>
                        <div class="col-md-5 text-center"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label class=" cursor" style="color: #444C57;" v-on:click="addQuestiontest()"><b>+</b>Add Another
                  Question</label>
              </div>
            </div>
            <!-- <div class="text-right">
              <base-button type="primary" size="md" @click.prevent="saveTest">
                Save Test
              </base-button>
            </div> -->
            <div class="clearfix"></div>
          </form>
          <form v-if="!main_test && !test_preview && test_question">
            <div class="row">
              <div class="col-md-3"></div>
              <div class="col-md-6">
                <label class="form-control-label">Upload Test Questions</label>
                <div>
                  <span class="">
                    <!-- accept=" .xlsx,csv,application/vnd.ms-excel" -->
                    <input type="file" name="..." class="form-control " v-on:change="getTestFile($event)" />
                  </span>
                </div>
                <h5 class="mt-2">
                  <a class="underline-class" href="/assets/uploadBulkTestQuestionAnswerFormat.csv" download
                    style="padding-right:5px; color:green;">Click here</a>
                  to download upload format.
                </h5>
              </div>
              <div class="col-md-3"></div>
            </div>
            <div class="mt-2 d-flex justify-content-end">
              <base-button type="primary" @click.prevent="openTestPreview">
                Upload Test
              </base-button>
              <!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
              <base-button type="primary" @click.prevent="backToMainTest">
                Cancel
              </base-button>
            </div>
            <div class="clearfix"></div>
          </form>
          <form v-if="!main_test && test_preview && !test_question">
            <div class="text-center my-3">
              <button type="submit" style="border:2px solid #272C33;background-color: transparent; color: #272C33;"
                class="btn  mt-3 btn-wd" @click.prevent="backToTestQuestion">
                Back
              </button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <button type="submit" style="background-color: #444C57;border:2px solid #444C57;"
                class="btn  mt-3  btn-wd" @click.prevent="saveTest">
                Save Test
              </button>
            </div>
            <div class="clearfix"></div>
          </form>
        </modal>
        <!--            end of test modal-->
        <!--                certificate modal-->
        <modal :show.sync="certificateModal">
          <h4 slot="header" style="color: #444C57" class="title title-up ">
            Add New Certificate
          </h4>
          <form>
            <div class="row">
              <div class="col-md-12">
                <h5 style="color: #444C57" class=" text-center">
                  Step 1: Enter Global Information
                </h5>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3"></div>
              <div class="col-md-6 col-12">
                <base-input type="text" label="Certificate Name" placeholder="Certificate Name"
                  v-model="certificate.certificate_name">
                </base-input>
              </div>
            </div>

            <hr />
            <div class="row">
              <div class="col-md-12">
                <h5 style="color: #444C57" class=" text-center">
                  Step 2: Customization
                </h5>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3"></div>
              <div class="col-md-6 col-12">
                <div class="form-group">
                  <base-input label="Signature Title 1" name="Signature Title 1" placeholder="Signature Title 1"
                    rules="required" v-model="certificate.certificate_signature_title_1">
                  </base-input>
                </div>
              </div>
              <div class="col-md-3"></div>
              <div class="col-md-3"></div>
              <div class="col-md-6 col-12">
                <div class="form-group">
                  <base-input label="Signature Title 2" name="Signature Title 2" placeholder="Signature Title 2"
                    v-model="certificate.certificate_signature_title_2">
                  </base-input>
                </div>
              </div>
              <div class="col-md-3"></div>
              <div class="col-md-3"></div>
              <div class="col-md-6 col-12">
                <div class="form-group">
                  <label>Custom Text</label>
                  <textarea rows="1" class="form-control border-input" placeholder="Custom Text Here..."
                    v-model="certificate.certificate_custom_text">
                  </textarea>
                </div>
              </div>
              <div class="col-md-3"></div>
            </div>
            <div class="text-center my-4">
              <base-button type="primary" size="sm" @click.prevent="saveCertificates">
                Add Certificate
              </base-button>
            </div>
            <div class="clearfix"></div>
          </form>
        </modal>
        <modal :show.sync="pretestModal" class="user-modal">
          <h2 slot="header" class="modal-title mb-0 ">
            Add Pre Test
          </h2>
          <div class="row">
            <div class="col-md-12 text-right">
              <base-button type="primary" @click.prevent="savePreTest">
                Save Pre Test
              </base-button>
            </div>

            <div class="col-md-12">
              <base-input v-model="pretest.name" label="Title *" placeholder="Enter pre test title"></base-input>
            </div>

            <div class="col-md-12">
              <label class="form-control-label">Instructions *</label>
              <vue-editor v-model="pretest.instructions"></vue-editor>
            </div>
          </div>

          <div class="brdr mt-3  question_box" v-for="(question, q_index) in pretest.pretest_questions"
            :key="question.id">
            <div class="">
              <div class="row align-items-center form-radio">
                <div class="col-md-3 d-flex align-items-center">
                  <h4 style="color: #444C57; margin-bottom:0;">Question {{ q_index + 1 }}</h4>
                  <div class="userstatus pl-4">
                    <div class="d-flex justify-content-md-end" v-on:click="changeStatus(props.$index, props.row)">
                      <base-switch class="mr-1" v-if="question.question_status" type="success"
                        :id="'testQuestion-switch_' + q_index" v-model="question.question_status"></base-switch>
                      <base-switch class="mr-1" v-else type="danger" v-model="question.question_status"
                        :id="'testQuestion-switch_' + q_index"></base-switch>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <label class="form-control-label" v-if="question.answer_type == 1">Map Field: </label>&nbsp;
                  <el-select v-if="question.answer_type == 1" v-model="question.is_update_employee">
                    <el-option v-for="option in updateEmployeeOptions" class="select-primary" :value="option.value"
                      :label="option.label" :key="option.value">
                    </el-option>
                  </el-select>
                  &nbsp;
                  <el-popover v-if="question.answer_type == 1" ref="fromPopOver" placement="top-start" width="250"
                    trigger="hover">
                    <span style="display: flex; justify-content: center;">
                      Selected option will be updated with user information.
                    </span>
                  </el-popover>
                  <span v-if="question.answer_type == 1">
                    <i v-popover:fromPopOver class="fa fa-info-circle
                    text-blue" />
                  </span>
                </div>
                <div class="col-md-4 col-6">
                  <!-- <div class="d-flex justify-content-md-end" v-on:click="changeStatus(props.$index, props.row)">
                    <base-switch class="mr-1" v-if="question.question_status" type="success"
                      :id="'testQuestion-switch_' + q_index" v-model="question.question_status"></base-switch>
                    <base-switch class="mr-1" v-else type="danger" v-model="question.question_status"
                      :id="'testQuestion-switch_' + q_index"></base-switch>
                  </div> -->
                </div>
                <div class="col-md-1 col-6">
                  <base-button type="" style="float:right;" size="sm" @click.prevent="removePreTestQuestion(q_index)">
                    <!-- <i class="fa fa-trash"></i> -->
                    <img class="ico-del" src="/img/icons/common/delete-icon.svg" alt="" />
                  </base-button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 questionbox">
                <textarea class="form-control form-control mt-2" type="text" placeholder="Question"
                  v-model="question.question">
                </textarea>
                <span class="text-danger small" v-if="isRequired &&
                  pretest_save_clicked &&
                  question.question === '' &&
                  question.question_status
                ">Question Field is Required!</span>
              </div>

              <div class="col-md-4">
                <label class="form-control-label">Answer Type: </label>
                <el-select class="w-100" v-model="question.answer_type" placeholder="Select Answer Type">
                  <el-option v-for="option in answer_type" class="select-primary" :value="option.value"
                    :label="option.label" :key="option.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="row mt-2 mb-2" v-if="question.answer_type == 1">
              <div class="col-md-4">
                <div class="row">
                  <div class="col-md-12">
                    <label class="form-control-label">Select Validation</label>
                  </div>
                  <div class="col-md-12">
                    <el-select v-model="question.checked_validations" class="w-100">
                      <el-option v-for="text in validationtype" :key="text.value" :value="text.value"
                        :label="text.label"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <label class="form-control-label" style="color: #28c0e7;">Preview</label>

                <base-input v-model="previewPhone" v-if="question.checked_validations == 1" placeholder="(555) 555-5555"
                  @input="acceptNumber"></base-input>
                <base-input type="email" name="Email" v-model="previewEmail" v-if="question.checked_validations == 2"
                  placeholder="Enter valid email"></base-input>
                <base-input v-model="previewText" v-if="question.checked_validations == 3"
                  placeholder="Enter Text"></base-input>
                <el-date-picker v-model="previewDate" v-if="question.checked_validations == 4" style="width: 100%"
                  type="date" placeholder="Pick a day" format="MM/dd/yyyy" :picker-options="pickerOptions1">
                </el-date-picker>
                <base-input v-model="previewSsn" v-if="question.checked_validations == 5"
                  placeholder="Enter SSN"></base-input>
              </div>
            </div>

            <div class="row " v-if="question.answer_type == 2">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-8">
                    <div class="row">
                      <div class="col-sm-7 col-7"></div>
                    </div>
                    <div class="row" v-for="(option, o_index) in question.answers" :key="option.id">
                      <div class="col-sm-6 col-7 mt-2">
                        <base-input type="text" :label="'Answer Option ' + (o_index + 1)" placeholder="Option"
                          v-model="option.answer">
                        </base-input>
                        <span class="text-danger small" v-if="isRequired &&
                          pretest_save_clicked &&
                          option.answer === '' &&
                          question.question_status
                        ">Option Field is Required!</span>
                      </div>
                      <div class="col-sm-5  col-5 mt-md-5">
                        <base-button size="sm" type="" @click.prevent="removePreTestOption(q_index, o_index)">
                          <!-- <i class="fa fa-trash"></i> -->
                          <img class="ico-del" src="/img/icons/common/delete-icon.svg" alt="" />
                        </base-button>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-7">
                        <label style="color: #444C57;" class=" cursor" v-on:click="addPreOptionTest(q_index)"><b
                            class="mr-1">+</b>Add Another Option</label>
                      </div>
                      <div class="col-md-5 text-center"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-12">
              <label class=" cursor" style="color: #444C57;" v-on:click="addQuestionPretest()"><b>+</b>Add Another
                Question</label>
            </div>
          </div>
          <!-- <div class="text-right">
            <base-button type="primary" size="md" @click.prevent="savePreTest">
              Save Pre Test
            </base-button>
          </div> -->
        </modal>
        <!-- Survey  -->
        <modal :show.sync="surveytestModal" class="user-modal">
          <h4 slot="header" class="modal-title mb-0">
            Add Survey Test
          </h4>
          <div class="row">
            <div class="col-md-12 text-right">
              <base-button type="primary" @click.prevent="saveSurveyTest">
                Save Survey Test
              </base-button>
            </div>
            <div class="col-md-12">
              <base-input v-model="surveytest.name" label="Title *" placeholder="Enter Survey test title"></base-input>
            </div>
            <div class="col-md-12">
              <label class="form-control-label">Instructions *</label>
              <vue-editor v-model="surveytest.instructions"></vue-editor>
            </div>
          </div>

          <div class="brdr question_box mt-3" v-for="(question, q_index) in surveytest.surveytest_questions"
            :key="question.id">
            <div class="row align-items-center form-radio">
              <div class="col-md-7 d-flex align-items-center">
                <h4 style="color: #444C57; margin-bottom: 0;">Question {{ q_index + 1 }}</h4>
                <div class="userstatus pl-4">
                  <div class="d-flex justify-content-md-end" v-on:click="changeStatus(props.$index, props.row)">
                    <base-switch class="mr-1" v-if="question.question_status" type="success"
                      :id="'testQuestion-switch_' + q_index" v-model="question.question_status"></base-switch>
                    <base-switch class="mr-1" v-else type="danger" v-model="question.question_status"
                      :id="'testQuestion-switch_' + q_index"></base-switch>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-6 userstatus">
                <!-- <div class="d-flex justify-content-md-end" v-on:click="changeStatus(props.$index, props.row)">
                  <base-switch class="mr-1" v-if="question.question_status" type="success"
                    :id="'testQuestion-switch_' + q_index" v-model="question.question_status"></base-switch>
                  <base-switch class="mr-1" v-else type="danger" v-model="question.question_status"
                    :id="'testQuestion-switch_' + q_index"></base-switch>
                </div> -->
              </div>
              <div class="col-md-1 col-6 ">
                <base-button type="" style="float:right;" size="sm" @click.prevent="removeSurveyTestQuestion(q_index)">
                  <!-- <i class="fa fa-trash"></i> -->
                  <img class="ico-del" src="/img/icons/common/delete-icon.svg" alt="" />
                </base-button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 pt-2 pb-4">
                <textarea class="form-control" type="text" placeholder="Question" v-model="question.question">
                </textarea>
                <span class="text-danger small" v-if="isRequired &&
                  surveytest_save_clicked &&
                  question.question === '' &&
                  question.question_status
                ">Question Field is Required!</span>
              </div>

              <div class="col-md-4">
                <label class="form-control-label">Answer Type: </label>
                <el-select class="w-100" v-model="question.answer_type" placeholder="Select Answer Type">
                  <el-option v-for="option in answer_type" class="select-primary" :value="option.value"
                    :label="option.label" :key="option.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="row mt-2 mb-2" v-if="question.answer_type == 1">
              <div class="col-md-4">
                <div class="row">
                  <div class="col-md-12">
                    <label class="form-control-label">Select Validation </label>
                  </div>
                  <div class="col-md-12">
                    <el-select v-model="question.checked_validations" class="w-100">
                      <el-option v-for="text in validationtype" :key="text.value" :value="text.value"
                        :label="text.label"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <label class="form-control-label">Preview </label>
                <base-input v-model="previewPhone" v-if="question.checked_validations == 1" placeholder="(555) 555-5555"
                  @input="acceptNumber"></base-input>
                <base-input type="email" name="Email" v-model="previewEmail" v-if="question.checked_validations == 2"
                  placeholder="Enter valid email"></base-input>
                <base-input v-model="previewText" v-if="question.checked_validations == 3"
                  placeholder="Enter Text"></base-input>
                <el-date-picker v-model="previewDate" v-if="question.checked_validations == 4" style="width: 100%"
                  type="date" placeholder="Pick a day" format="MM/dd/yyyy" :picker-options="pickerOptions1">
                </el-date-picker>
                <base-input v-model="previewSsn" v-if="question.checked_validations == 5"
                  placeholder="Enter SSN"></base-input>
              </div>
            </div>

            <div class="row " v-if="question.answer_type == 2">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-8">
                    <div class="row">
                      <div class="col-sm-7 col-7"></div>
                    </div>
                    <div class="row" v-for="(option, o_index) in question.answers" :key="option.id">
                      <div class="col-sm-6 col-7 mt-2">
                        <base-input type="text" :label="'Answer Option ' + (o_index + 1)" placeholder="Option"
                          v-model="option.answer">
                        </base-input>
                        <span class="text-danger small" v-if="isRequired &&
                          surveytest_save_clicked &&
                          option.answer === '' &&
                          question.question_status
                        ">Option Field is Required!</span>
                      </div>
                      <div class="col-sm-5  col-5 mt-md-5">
                        <base-button size="sm" type="" @click.prevent="
                          removeSurveyTestOption(q_index, o_index)
                          ">
                          <!-- <i class="fa fa-trash"></i> -->
                          <img class="ico-del" src="/img/icons/common/delete-icon.svg" alt="" />
                        </base-button>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-7">
                        <label style="color: #444C57;" class=" cursor" v-on:click="addSurveyOptionTest(q_index)"><b
                            class="mr-1">+</b>Add Another Option</label>
                      </div>
                      <div class="col-md-5 text-center"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-12">
              <label class=" cursor" style="color: #444C57;" v-on:click="addQuestionSurveytest()"><b>+</b>Add Another
                Question</label>
            </div>
          </div>
          <!-- <div class="text-right">
            <base-button type="primary" @click.prevent="saveSurveyTest">
              Save Survey Test
            </base-button>
          </div> -->
        </modal>
        <!--                Gamification modal-->
        <modal :show.sync="gamifiedModel" v-on:close="closegamification()">
          <h4 slot="header" style="color: #444c57" class="modal-title mb-0">
            Add Content
          </h4>
          <form>
            <div class="row">
              <div class="col-md-12 mt-1" v-for="(content, c_index) in lesson.gamified_content" :key="c_index">
                <span :id="'hidegamfication_' + c_index">
                  <h4>Content {{ c_index + 1 }}</h4>
                  <vue-editor :editorOptions="editorSettings" v-model="content.text"></vue-editor>
                </span>

              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-6">
                <base-button v-if="currindex == '0'" disabled style="float: left" size="sm" class="previous"
                  @click="removeAnotherEditor()">Previous
                </base-button>
                <base-button v-else style="float: left" size="sm" class="previous"
                  @click="removeAnotherEditor()">Previous
                </base-button>
              </div>
              <div class="col-md-6">
                <base-button style="float: right" size="sm" @click="addAnotherEditor()">Next
                </base-button>
              </div>
              <div class="col-md-12 mt-4">
                <base-button style="float: right" @click="closegamification">Done
                </base-button>
              </div>
            </div>
            <div class="clearfix"></div>
          </form>
          <!---------- Gamification close ---------->
        </modal>
      </card>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { DatePicker, Table, TableColumn, Select, Option, Progress, Checkbox } from "element-ui";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
// import { TheMask } from "vue-the-mask";
import FileInput from "@/components/Inputs/FileInput";
import { Modal, BaseAlert } from "@/components";
import { VueEditor, Quill } from "vue2-editor";
import ImageResize from "quill-image-resize-vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import BaseCheckbox from "../../components/Inputs/BaseCheckbox.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import { Money } from "v-money";
import axios from "axios"; // Import Axios
import jsPDF from 'jspdf';

Quill.register("modules/imageResize", ImageResize);
Vue.component("v-select", vSelect);
export default {
  components: {
    // PreTest,
    VueTimepicker,
    [DatePicker.name]: DatePicker,
    [Progress.name]: Progress, // Register Progress component
    VueEditor,
    Modal,
    // TheMask,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Checkbox.name]: Checkbox,
    FileInput,
    Money,
    BaseCheckbox
  },
  data() {
    return {
      //generate course with AI related properties
      editor: "",
      isCancelled: false,
      editableCourseText: '',
      generatedPdfBlob: null,
      generateAIModal: false,
      showCourseTypeModal: false,
      showPDFLoading: false,
      showPDFPreviewModal: false,
      loadingMessage: 'Please wait a moment while we automatically generate the course content for you. This will take about a minute.',
      submitMessage: "Your course has been submitted! Our Home of Training support team will notify you when your new course is ready.",
      aiForm: {
        name: '',
        description: '',
        length: null,
        level: '',
        tone: '',
        objectives: '',
        questionCount: 5,
        questionTypes: [],
        includeStockMedia: 'no',
        uploadOwnMedia: 'No',
        uploadedMediaFiles: [],
        accessibility: [],
        stateSpecific: false,
        states: '',
        languages: '',
        revisionPrompt: '',
        courseType: '',
        industry: ''
      },
      dropdownOpen: false,
      educationLevels: ['Entry-Level', 'Intermediate', 'Advanced'],
      toneDropdownOpen: false,
      toneOptions: ['Professional', 'Conversational', 'Fun'],
      courseTypeDropdownOpen: false,
      courseTypeOptions: ['PDF', 'SCORM', 'Video'],
      uploadOwnMediaDropdownOpen: false,
      uploadOwnMediaOptions: ['Yes', 'No'],
      questionTypeOptions: [
        'Multiple Choice',
        'True/False',
        'Matching',
        'Fill in the Blank'
      ],
      generatedContent: null,
      loadingAI: false,
      showResultsOnly: false,
      readyToGenerateDescription: false,
      loadingDescription: false,
      lastGeneratedName: "",
      showSuccessModal: false,
      // New progress-related properties
      progress: 0,
      progressTimer: null,
      showProgress: false,
      editorSettings: {
        modules: {
          imageResize: {}
        }
      },
      //Gamification properties
      currindex: 0,
      hideGamificationBlock: true,
      closegamification: false,
      baseUrl: this.$baseUrl,
      checked_validations: "",
      loading: false,
      duplicateFlag: false,
      pretestModal: false,
      saving: false,
      hot_user: "",
      company_id:"",
      company_name:"",
      hot_token: "",
      config: "",
      //   courses_data: [],
      certificate_Data: [],
      surveyData: [],
      percentage: {
        thousands: ",",
        prefix: "",
        suffix: "%",
        masked: false /* doesn't work with directive */
      },
      money: {
        decimal: ".",
        thousands: ",",
        prefix: "$",
        suffix: "",
        precision: 2,
        masked: false /* doesn't work with directive */
      },
      courseImage: null,
      lesson_preview: false,
      test_question: false,
      main_test: true,
      test_preview: false,
      updating: false,

      lesson_save_clicked: false,
      isRequired: true,
      test_save_clicked: false,
      courses: [],
      company_specific: [],
      question_type: [
        {
          label: "Text",
          value: "1"
        },
        {
          label: "Option",
          value: "2"
        }
      ],
      max: 38,
      course: {
        live: true,
        popular:false,
        hrbasics:false,
        status: true,
        classification: "",
        course_name: "",
        secondary_course_name: "",
        course_name_certificate: "",
        course_length: "",
        course_due: "",
        allowed_attempts: "",
        coursestatus: "",
        course_passmessage: "",
        course_failmessage: "",
        course_cost: "",
        course_description: "",
        course_resources: [],
        course_pass_rate: "",
        formanager: true,
        foremployee: true,
        certificateavilable: true,
        nextcourse: "0",
        companyspecific: "",
        employees_days_to_complete: "",
        manager_days_to_complete: "",
        reassignment_expiry: true,
        expiry_attempts: "",
        certificate_validity: "",
        assignment_gap: "",
        course_lessons: [],
        course_test: [],
        course_pretest: [],
        course_surveytest: [],
        course_certificate: "",
        course_survey: "",
        course_type: false,
        course_2fa: false,
        discounted_course: false,
        discounted_course_comment: "",
        weekly_report: false,
        food_safe_online_proctored_exam: false,
        assigned_companies_id: [],
        courseResources: [],
        isScorm: false,
        scormFile: null,
        scorm_version: "1"
      },
      companies: [],
      lessonModal: false,
      certificateModal: false,
      testModal: false,
      lesson: {
        nextButtonTimerStatus: false,
        timerValue: "",
        quizStatus: false,
        lesson_type: "Select Type",
        lesson_name: "",
        allowed_attempts: "",
        passing_rate: "",
        no_of_questions: "",
        lesson_video_url: "",
        youtube_lesson_video_url: "",
        gamified_content: [
          {
            text: "",
          },
        ],
        lesson_pdf_url: "",
        lesson_content: "",
        lesson_quiz_instruction: "",
        lesson_questions: [
          {
            question_text: "",
            allowed_attempts: "",
            question_status: true,
            options: [
              {
                option_text: "",
                correct: false
              }
            ]
          }
        ]
      },
      processing: false,
      test: {
        practice_test: 0,
        enable_submit_button: "",
        test_instruction: "",
        test_pass_message: "",
        test_fail_message: "",
        test_no_of_questions: "",
        test_questions: [
          {
            question_text: "",
            question_status: true,
            allowed_attempts: "",
            options: [
              {
                option_text: "",
                correct: false
              }
            ]
          }
        ]
      },
      lessontype: [
        {
          label: "Vimeo video",
          value: "video"
        },
        {
          label: "YouTube video",
          value: "youtube-video"
        },
        {
          label: "Pdf",
          value: "pdf"
        }, {
          label: "Gamification",
          value: "gamification",
        },
      ],
      updateEmployeeOptions: [
        {
          label: "Dob",
          value: 1
        },
        {
          label: "SSN",
          value: 2
        },
        {
          label: "Address",
          value: 3
        },
        {
          label: "City",
          value: 4
        },
        {
          label: "State",
          value: 5
        },
        {
          label: "Email",
          value: 6
        },
        {
          label: "Phone number",
          value: 7
        }
      ],
      resourceType: [
        {
          label: "Link",
          value: "link"
        },
        {
          label: "File",
          value: "file"
        }
      ],
      certificate: {
        certificate_name: "",
        course_id: "",
        certificate_date: "",
        certificate_valid_time: "",
        certificate_custom_text: "",
        certificate_signature_title_1: "",
        certificate_signature_title_2: ""
      },

      requiredFeilds: "",
      selected: {
        simple: "",
        countries: [],
        multiple: "ARS"
      },
      pretest_save_clicked: false,
      surveytest_save_clicked: false,
      excel_data: {
        test_question: "",
        option_1: "",
        option_2: "",
        option_3: "",
        option_4: "",
        correct_answer: "",
        question_status: "",
        file: ""
      },
      previewPhone: "",
      previewEmail: "",
      previewText: "",
      previewSsn: "",
      previewDate: "",
      answer_type: [
        {
          label: "Text",
          value: 1
        },
        {
          label: "Option",
          value: 2
        }
      ],
      validationtype: [
        {
          label: "Please Select validation",
          value: 0
        },
        {
          label: "Phone number",
          value: 1
        },
        {
          label: "Email",
          value: 2
        },
        {
          label: "Text",
          value: 3
        },
        {
          label: "Date",
          value: 4
        },
        {
          label: "SSN",
          value: 5
        }
      ],

      pickerOptions1: {
        shortcuts: [
          {
            text: "Today",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "Yesterday",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            }
          },
          {
            text: "A week ago",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          }
        ]
      },
      gamifiedModel: false,
      surveytestModal: false,
      surveyQuizModal: false,
      pretestQuizModal: false,
      surveytest: {
        name: "",
        instructions: "",
        no_of_questions: "",
        type: "course",
        surveytest_questions: [
          {
            question: "",
            answer_type: "",
            question_status: true,
            checked_validations: "",
            answers: [
              {
                answer: "",
                correct_answer: false
              }
            ]
          }
        ]
      },
      courseResources: [],
      course_id: "",
      checkedNames: [],
      pretest: {
        name: "",
        instructions: "",
        no_of_questions: "",
        pretest_questions: [
          {
            question: "",
            is_update_employee: "",
            answer_type: "",
            question_status: true,
            checked_validations: "",
            answers: [
              {
                answer: "",
                correct_answer: false
              }
            ]
          }
        ]
      },
      hideFieldsFromCompanyAdmin: false,
    };
  },
  mounted() {

    if (localStorage.getItem("hot-user") === "employee") {
      this.editor = "employee";
    } else if (localStorage.getItem("hot-user") === "super-admin") {
      this.editor = "super-admin";
    } else if (localStorage.getItem("hot-user") === "sub-admin") {
      this.editor = "sub-admin";
      this.getRightsDetails();
    } else if (localStorage.getItem("hot-user") === "company-admin") {
      this.editor = "company";
    } else if (localStorage.getItem("hot-sidebar") === "manager") {
      this.editor = "manager";
    }

    console.log(this.editor, "EDITOR");

    const origin = this.$route.query.origin;
    if(origin != undefined){
      this.generateAIModal = true
    }
  },
  watch: {
    "lesson.lesson_type"(val) {
      if (val === "gamification") {
        this.openGamificationModel();
      }
    },
  },
  created() {
    if (localStorage.getItem("hot-token")) {
      this.hot_user = localStorage.getItem("hot-user");
      if(this.hot_user==='company-admin'){
        this.company_id = localStorage.getItem("hot-user-id");
        this.company_name = localStorage.getItem("hot-company-name");
      }
      this.hot_token = localStorage.getItem("hot-token");
    }

    if (localStorage.getItem("hot-user") !== "super-admin") {
      this.course.live = false;
      this.course.popular = false;
      this.course.hrbasics = false;
      this.hideFieldsFromCompanyAdmin = true;
    }

    this.config = {
      headers: {
        authorization: "Bearer " + localStorage.getItem("hot-token"),
        "content-type": "application/json"
      }
    };
    this.$http.get("course/unassignedCertificates", this.config).then(resp => {
      this.certificate_Data = [];
      for (let certificate of resp.data) {
        let obj = {
          id: certificate.id,
          certificate_name: certificate.name
        };
        this.certificate_Data.push(obj);
      }
    });
    this.getSurvey();

    if (this.$route.query.id) {
      let duplicate_id = this.$route.query.id;
      this.loading = true;
      this.$http
        .get("/course/edit/" + duplicate_id, this.config)
        .then(resp => {
          this.duplicateFlag = true;
          let data = resp.data[0];
          let course_obj = {
            popular: "",
            hrbasics: "",
            live: "",
            status: "",
            formanager: "",
            foremployee: "",
            classification: data.classification || "",
            course_name: data.name,
            secondary_course_name: data.secondary_course_name,
            course_name_certificate: data.course_name_certificate,
            course_length: data.length,
            employees_days_to_complete: data.employees_days_to_complete,
            manager_days_to_complete: data.managers_days_to_complete,
            reassignment_expiry: data.reassignment_expiry,
            expiry_attempts: data.expiry_attempts,

            course_pass_rate: data.passing_percent,
            nextcourse: data.next_course,
            companyspecific: data.company_specific,
            course_type: data.course_type,
            course_2fa: data.is_2fa_required,
            discounted_course: data.is_discounted_course,
            discounted_course_comment: data.discounted_course_comment,
            weekly_report: data.is_weekly_report,
            food_safe_online_proctored_exam:
              data.food_safe_online_proctored_exam,
            assignment_gap: data.assignment_gap,
            certificate_validity: data.certificate_validity,
            certificateavilable: data.certificate_available,
            //course_due: data.due_days,
            allowed_attempts: data.allow_attempts,
            course_cost: data.cost,
            course_passmessage: data.pass_message,
            course_failmessage: data.fail_message,
            course_description: data.description,
            course_resources: [],
            course_lessons: [],
            course_test: [],
            course_pretest: [],
            course_surveytest: [],
            course_certificate: "",
            assigned_companies_id: [],
            courseResources: []
          };
          if (data.in_store === 1) {
            course_obj.live = true;
          } else if (data.in_store === 0) {
            course_obj.live = false;
          } else {
            course_obj.live = data.in_store;
          }
          if (data.is_popular === 1) {
            course_obj.popular = true;
          } else if (data.is_popular === 0) {
            course_obj.popular = false;
          } else {
            course_obj.popular = data.is_popular;
          }
          if (data.is_hrbasics === 1) {
            course_obj.hrbasics = true;
          } else if (data.is_hrbasics === 0) {
            course_obj.hrbasics = false;
          } else {
            course_obj.hrbasics = data.is_hrbasics;
          }
          if (data.for_managers === 1) {
            course_obj.formanager = true;
          } else if (data.for_managers === 0) {
            course_obj.formanager = false;
          } else {
            course_obj.formanager = data.for_managers;
          }
          if (data.for_employees === 1) {
            course_obj.foremployee = true;
          } else if (data.for_employees === 0) {
            course_obj.foremployee = false;
          } else {
            course_obj.formanager = data.for_employees;
          }

          if (data.certificate_available === 1) {
            course_obj.certificateavilable = true;
          } else if (data.certificate_available === 0) {
            course_obj.certificateavilable = false;
          } else {
            course_obj.certificateavilable = data.certificate_available;
          }
          let course_companies = data.course_companies;
          for (let companies of course_companies) {
            course_obj.assigned_companies_id.push(companies.id);
          }
          for (let courseResource of data.courseResources) {
            course_obj.courseResources.push(courseResource.id);
          }
          if (data.status === 1) {
            course_obj.status = true;
          } else if (data.status === 0) {
            course_obj.status = false;
          } else {
            course_obj.status = data.status;
          }
          let lesson_data = data.lessons;
          for (let lesson of lesson_data) {
            let lesson_obj = {
              id: lesson.id,
              allowed_attempts: lesson.allowed_attempts,
              course_passmessage: lesson.course_passmessage,
              lesson_name: lesson.course_lesson_name,
              lesson_type: lesson.type,
              passing_rate: lesson.passing_rate,
              quizStatus: "",
              no_of_questions: lesson.no_of_questions,
              lesson_content: lesson.course_lesson_content,
              lesson_quiz_instruction: lesson.course_lesson_quiz,
              lesson_questions: []
            };
            if (lesson.quiz_status == 1) {
              lesson_obj.quizStatus = true;
            } else if (lesson.quiz_status == 0) {
              lesson_obj.quizStatus = false;
            } else {
              lesson_obj.quizStatus = lesson.quiz_status;
            }
            if (lesson.type == "video" && lesson.course_lesson_video) {
              lesson_obj.lesson_video_url = lesson.course_lesson_video.substr(
                31
              );
            } else {
              lesson_obj.lesson_pdf_url = lesson.course_lesson_video;
            }
            for (let question of lesson.questions) {
              let question_obj = {
                id: question.id,
                question_text: question.question,
                // allowed_attempts:question.allowed_attempts,
                question_status: "",
                options: []
              };
              if (question.status === 1) {
                question_obj.question_status = true;
              } else if (question.status === 0) {
                question_obj.question_status = false;
              }
              for (let option of question.answers) {
                let option_obj = {
                  id: option.id,
                  option_text: option.course_quiz_question_option,
                  correct: ""
                };
                if (option.course_quiz_correct_answer === 1) {
                  option_obj.correct = true;
                } else if (option.course_quiz_correct_answer === 0) {
                  option_obj.correct = false;
                }
                question_obj.options.push(option_obj);
              }
              lesson_obj.lesson_questions.push(question_obj);
            }
            course_obj.course_lessons.push(lesson_obj);
          }

          let tests_data = data.tests;
          for (let test of tests_data) {
            let test_obj = {
              id: test.id,
              practice_test: test.practice_test,
              enable_submit_button: test.enable_submit_button,
              test_instruction: test.course_test_instruction,
              test_pass_message: test.course_test_pass_msg,
              test_fail_message: test.course_test_fail_msg,
              test_no_of_questions: test.course_no_of_questions,
              test_questions: []
            };
            for (let question of test.questions) {
              let question_obj = {
                id: question.id,
                question_text: question.question,
                allowed_attempts: question.allowed_attempts,
                question_status: "",
                options: []
              };
              if (question.status === 1) {
                question_obj.question_status = true;
              } else if (question.status === 0) {
                question_obj.question_status = false;
              }
              for (let option of question.answers) {
                let option_obj = {
                  id: option.id,
                  option_text: option.course_quiz_question_option,
                  correct: ""
                };
                if (option.course_quiz_correct_answer === 1) {
                  option_obj.correct = true;
                } else if (option.course_quiz_correct_answer === 0) {
                  option_obj.correct = false;
                }
                question_obj.options.push(option_obj);
              }
              test_obj.test_questions.push(question_obj);
            }
            course_obj.course_test.push(test_obj);
          }
          let pretest = data.pretest;
          if (pretest != null && pretest != "") {
            let pretest_obj = {
              id: pretest.id,
              name: pretest.name,
              instructions: pretest.instruction,
              pretest_questions: []
            };
            for (let question of pretest.questions) {
              let question_obj = {
                id: question.id,
                question: question.question,
                is_update_employee: question.is_update_employee,
                answer_type: question.question_type,
                checked_validations: question.validation,
                question_status: "",
                answers: []
              };
              if (question.status === 1) {
                question_obj.question_status = true;
              } else if (question.status === 0) {
                question_obj.question_status = false;
              }

              for (let answer of question.answers) {
                let option_obj = {
                  id: answer.id,
                  answer: answer.answer
                };
                question_obj.answers.push(option_obj);
              }

              pretest_obj.pretest_questions.push(question_obj);
            }
            course_obj.course_pretest.push(pretest_obj);
          }

          let surveytests = data.survey;
          for (let surveytest of surveytests) {
            let surveytest_obj = {
              id: surveytest.id,
              name: surveytest.name,
              instructions: surveytest.instruction,
              surveytest_questions: []
            };
            for (let question of surveytest.questions) {
              let question_obj = {
                id: question.id,
                question: question.question,
                answer_type: question.question_type,
                checked_validations: question.validation,
                question_status: "",
                answers: []
              };
              if (question.status === 1) {
                question_obj.question_status = true;
              } else if (question.status === 0) {
                question_obj.question_status = false;
              }

              for (let answer of question.answers) {
                let option_obj = {
                  id: answer.id,
                  answer: answer.answer
                };
                question_obj.answers.push(option_obj);
              }

              surveytest_obj.surveytest_questions.push(question_obj);
            }
            course_obj.course_surveytest.push(surveytest_obj);
          }
          let certificate_data = data.certificates;
          for (let certificate of certificate_data) {
            course_obj.course_certificate = certificate.id;
          }
          this.course = course_obj;
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 422) {
            Swal.fire({
              title: "Error!",
              text: error.response.data.message,
              icon: "error",
              confirmButtonClass: 'btn btn-success',
              confirmButtonText: 'Ok'
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: "Something went wrong.",
              icon: "error",
              confirmButtonClass: 'btn btn-success',
              confirmButtonText: 'Ok'
            });
          }
        })
        .finally(() => (this.loading = false));
    }
    this.$http
      .post(
        "course/all_courses",
        {
          course_status: "Active"
        },
        this.config
      )
      .then(resp => {
        let courses = resp.data.courses;
        this.courses = [
          {
            label: "None",
            value: "0"
          },
          {
            label: "This Course",
            value: "this_course"
          }
        ];
        for (let course of courses) {
          let obj = {
            label: course.name,
            value: course.id
          };

          this.courses.push(obj);
        }
      });
    this.$http
      .post(
        "company/all_companies",
        {
          company_type: "parent"
        },
        this.config
      )
      .then(resp => {
        let comp_data = resp.data.companies;
        let let_obj = {
          label: "Select",
          value: 0
        };
        this.company_specific.push(let_obj);
        for (let data of comp_data) {
          let obj = {
            label: data.name,
            value: data.id
          };

          this.company_specific.push(obj);
          this.companies.push(obj);
        }
      });

    this.$http.get("/resources").then(response => {
      this.courseResources = response.data.resources;
    });
  },
  directives: {
    autoResize: {
      inserted(el) {
        el.style.overflow = 'hidden';
        el.style.minHeight = '3em';
        el.addEventListener('input', () => {
          el.style.height = 'auto';
          el.style.height = el.scrollHeight + 'px';
        });
        // Run once on mount
        el.dispatchEvent(new Event('input'));
      }
    }
  },
  methods: {
    limitCourseLength(event) {
      const value = event.target.value;
      if (value.length > 3) {
        event.target.value = value.slice(0, 3);
        this.aiForm.length = Number(event.target.value);
      }
    },
    limitQuestionCount(event) {
      const value = event.target.value;
      if (value.length > 2) {
        event.target.value = value.slice(0, 2);
        this.aiForm.questionCount = Number(event.target.value);
      }

      // Extra protection in case user pastes 3+ digits directly
      if (this.aiForm.questionCount > 99) {
        this.aiForm.questionCount = 99;
      }
    },
    toggleDropdown() {
      console.log(this.dropdownOpen);

      this.dropdownOpen = !this.dropdownOpen;
    },
    selectLevel(level) {
      this.aiForm.level = level;
      this.dropdownOpen = false;
    },
    toggleToneDropdown() {
      this.toneDropdownOpen = !this.toneDropdownOpen;
    },
    selectTone(tone) {
      this.aiForm.tone = tone;
      this.toneDropdownOpen = false;
    },
    toggleCourseTypeDropdown() {
      this.courseTypeDropdownOpen = !this.courseTypeDropdownOpen;
    },
    selectCourseType(option) {
      this.aiForm.courseType = option;
      this.courseTypeDropdownOpen = false;
    },
    toggleUploadOwnMediaDropdown() {
      this.uploadOwnMediaDropdownOpen = !this.uploadOwnMediaDropdownOpen;
    },
    selectUploadOwnMedia(option) {
      this.aiForm.uploadOwnMedia = option;
      this.uploadOwnMediaDropdownOpen = false;
    },
    validateNumberInput(value) {
      const onlyDigits = value.replace(/\D/g, ''); // remove non-digits
      this.course.certificate_validity = onlyDigits;
    },
    //AI methods
    parseGeneratedContent(raw) {
      try {
        const cleaned = raw.replace(/,\s*(\]|\})/g, '$1');
        const parsed = JSON.parse(cleaned);

        // Optional: fallback defaults to avoid errors if some keys are missing
        return {
          title: parsed.title || '',
          description: parsed.description || '',
          objectives: parsed.objectives || [],
          lessons: parsed.lessons || [],
          questions: parsed.questions || [],
          resources: parsed.resources || []
        };
      } catch (e) {
        console.error('Failed to parse JSON from OpenAI:', e);
        return {
          title: '',
          description: '',
          objectives: [],
          lessons: [],
          questions: [],
          resources: []
        };
      }
    },
    formatGeneratedContent(content) {
      let output = `Course Title: ${content.title}\n\n`;

      if (content.description) {
        output += `Course Description: ${content.description}\n\n`;
      }

      output += `🎯 Course Objectives:\n`;
      content.objectives.forEach((obj, i) => {
        output += `- ${obj}\n`;
      });

      output += `\n📘 Lessons:\n`;
      content.lessons.forEach((lesson, i) => {
        output += `${i + 1}. ${lesson.title}\n${lesson.body}\n\n`;
      });

      output += `❓ Quiz Questions:\n`;
      content.questions.forEach((q, i) => {
        output += `${i + 1}. [${q.type}] ${q.question}\n`;

        if (Array.isArray(q.options)) {
          q.options.forEach((opt) => {
            const mark = opt === q.answer ? ' ✅' : '';
            output += `  - ${opt}${mark}\n`;
          });
        }

        output += `Answer: ${q.answer}\n\n`;
      });

      output += `📚 Study Resources:\n`;
      content.resources.forEach((res) => {
        output += `- ${res}\n`;
      });

      return output;
    },

    parseFormattedContent(text) {
      try {
        const lines = text.split('\n');
        const result = {
          title: '',
          description: '',
          objectives: [],
          lessons: [],
          questions: [],
          resources: []
        };

        let section = '';
        let currentLesson = null;
        let currentQuestion = null;

        for (let line of lines) {
          line = line.trim();

          if (!line) continue;

          // Section switches
          if (line.startsWith('Course Title:')) {
            result.title = line.replace('Course Title:', '').trim();
            continue;
          }

          if (line.startsWith('Course Description:')) {
            result.description = line.replace('Course Description:', '').trim();
            continue;
          }

          if (line.startsWith('🎯')) {
            section = 'objectives';
            continue;
          }

          if (line.startsWith('📘')) {
            section = 'lessons';
            continue;
          }

          if (line.startsWith('❓')) {
            section = 'questions';
            continue;
          }

          if (line.startsWith('📚')) {
            section = 'resources';
            continue;
          }

          // Objectives
          if (section === 'objectives' && line.startsWith('-')) {
            result.objectives.push(line.slice(1).trim());
            continue;
          }

          // Lessons
          if (section === 'lessons' && /^\d+\.\s/.test(line)) {
            if (currentLesson) result.lessons.push(currentLesson);
            currentLesson = { title: line.replace(/^\d+\.\s*/, ''), body: '' };
            continue;
          }

          if (section === 'lessons' && currentLesson) {
            currentLesson.body += (currentLesson.body ? ' ' : '') + line;
            continue;
          }

          // Questions
          if (section === 'questions' && /^\d+\.\s\[.*?\]/.test(line)) {
            if (currentQuestion) result.questions.push(currentQuestion);
            const match = line.match(/^\d+\.\s\[(.*?)\]\s(.+)/);
            currentQuestion = {
              type: match[1],
              question: match[2],
              options: [],
              answer: ''
            };
            continue;
          }

          if (section === 'questions' && line.startsWith('-')) {
            const cleaned = line.replace(/^-\s*/, '').replace('✅', '').trim();
            currentQuestion?.options.push(cleaned);
            continue;
          }

          if (section === 'questions' && line.startsWith('Answer:')) {
            currentQuestion.answer = line.replace('Answer:', '').trim();
            continue;
          }

          // Resources
          if (section === 'resources' && line.startsWith('-')) {
            result.resources.push(line.replace('-', '').trim());
            continue;
          }
        }

        if (currentLesson) result.lessons.push(currentLesson);
        if (currentQuestion) result.questions.push(currentQuestion);

        return result;
      } catch (err) {
        console.error('❌ Failed to parse editableCourseText', err);
        return null;
      }
    },

    handleEditedText(e) {
      // You could later add parsing logic if user edits this and you want to sync it back to an object
      // For now, we just hold the edited string
      this.editableCourseText = e.target.value;
    },
    openGenerateAIModal() {
      this.generateAIModal = true;
    },
    closeGenerateAIModal() {
      this.generateAIModal = false;
      this.showCourseTypeModal = false;
      this.showPDFLoading = false;
      this.showPDFPreviewModal = false;
      this.showResultsOnly = false;
      this.showSuccessModal = false;
      this.dropdownOpen = false;
      this.toneDropdownOpen = false;
      this.courseTypeDropdownOpen = false;
      this.loadingAI = false;
      this.loadingDescription = false;
      this.generatedContent = null;
      this.editableCourseText = '';
      this.lastGeneratedName = '';
      this.generatedPdfBlob = null;
      this.progress = 0;
      this.showProgress = false;
      this.isCancelled = true

      // Optional: clear progress timer if it's still running
      if (this.progressTimer) {
        clearInterval(this.progressTimer);
        this.progressTimer = null;
      }

      // Reset AI form
      this.resetAIForm();
    },
    handleBrandMediaUpload(e) {
      const allowedExtensions = ['jpg', 'jpeg', 'png', 'webp'];
      const maxSizeMB = 5;

      const files = Array.from(e.target.files);
      const validFiles = [];

      for (const file of files) {
        const extension = file.name.split('.').pop().toLowerCase();

        if (!allowedExtensions.includes(extension)) {
          alert(`Invalid format: ${file.name}. Allowed formats: JPG, JPEG, PNG, WEBP.`);
          continue;
        }

        if (file.size > maxSizeMB * 1024 * 1024) {
          alert(`File too large: ${file.name}. Max size is ${maxSizeMB}MB.`);
          continue;
        }

        validFiles.push(file);
      }

      this.aiForm.uploadedMediaFiles = validFiles;
    },
    async generateCourse() {
      this.isCancelled = false
      this.loadingAI = true;
      this.generatedContent = null;
      this.progress = 0;

      const interval = setInterval(() => {
        if (this.progress >= 95) {
          clearInterval(interval);
        } else {
          this.progress += 1;
        }
      }, 300);

      const {
        name,
        description,
        length,
        level,
        tone,
        languages,
        objectives,
        questionCount,
        questionTypes,
        includeStockMedia,
        uploadOwnMedia,
        accessibility,
        revisionPrompt,
        industry
      } = this.aiForm;


      // Build dynamic prompt
      let userPrompt = `Create a complete e-learning course for the ${industry} industry using the following details:\n\n`;

      userPrompt += `Course Title: ${name}\n`;
      userPrompt += `Course Description: ${description}\n`;
      userPrompt += `Education Level: ${level}\n`;
      userPrompt += `Preferred Tone: ${tone}\n`;

      let allLanguages = 'English';
      if (languages && languages.trim().toLowerCase() !== 'english') {
        allLanguages += `, ${languages.trim()}`;
      }
      userPrompt += `Languages: ${allLanguages}\n`;

      if (objectives) {
        userPrompt += `\nLearning Objectives:\n${objectives}\n`;
      }

      userPrompt += `\nPlease generate the following course content in English first and then provide the translated version for any additional languages if specified.\n`;

      userPrompt += `1. Course Objectives (bullet points)\n`;

      userPrompt += `2. Course Lessons:\n\n`;

      userPrompt += `IMPORTANT: After writing the lessons. The total combined word count must be between ${length * 100} and ${length * 120} words. Do not generate fewer than ${length * 100} words.\n\n`;

      userPrompt += `Each lesson must NOT be a summary. It should be fully written instructional content, not a high-level overview or lesson plan.\n\n`;

      userPrompt += `Create 4–6 structured lessons. Distribute the total word count evenly across lessons.\n\n`;

      userPrompt += `Each lesson must include:\n`;
      userPrompt += `- A clear title\n`;
      userPrompt += `- 3–5 rich paragraphs of instruction and explanation\n`;
      userPrompt += `- At least one real-world hospitality scenario or example\n`;
      userPrompt += `- Clear, immediately applicable takeaways\n\n`;

      userPrompt += `Write for a ${level.toLowerCase()} learner, using a ${tone.toLowerCase()} tone. Focus on clarity, practicality, and hospitality relevance.\n\n`;

      //userPrompt += `Make sure the overall course content is long, rich, and practical enough to reasonably fill ${length} minutes of learning time, including reading and quiz engagement.\n\n`;

      userPrompt += `3. Generate exactly ${questionCount || 5} quiz questions using ONLY the following types: ${questionTypes.length ? questionTypes.join(', ') : 'Multiple Choice'}.

      Use ONLY the following question types: ${questionTypes.join(', ')}. Do NOT use any types that are not listed.
      You must include **at least one** question of each selected type. If more questions are needed, repeat only from the selected types.
      Absolutely avoid using unlisted types, unless they were explicitly included. Distribute the question types **evenly** across the number of questions required.`

      userPrompt += `4. For all questions:\n`;
      userPrompt += `- Phrase each as a full, factual statement that can be logically evaluated.\n`;
      userPrompt += `- True/False questions must be written as complete assertions (e.g., "Personalized service increases guest satisfaction.") — NOT as questions.\n`;
      userPrompt += `- Multiple Choice questions must include 3–4 clearly worded options with only one correct answer, and the correct answer must be clearly marked.\n`;
      userPrompt += `**For Fill in the Blank questions**, you must include a blank space (use "______") in place of the missing word or phrase. Do NOT write a completed sentence. The answer should NOT be visible in the sentence. Example format:
      - Question: "Effective communication requires ______ and active listening."
      - Answer: "empathy"`

      if (includeStockMedia === 'yes') {
        userPrompt += `\n5. Include references to relevant stock images, icons, or video clips (describe them in text).\n`;
      }

      if (uploadOwnMedia === 'yes') {
        userPrompt += `6. The user has uploaded their own brand media. Please assume some will be inserted into the appropriate parts of the course.\n`;
      }

      if (accessibility.includes('captions')) {
        userPrompt += `\nSupport captions for all audio/video content.`;
      }
      if (accessibility.includes('audio')) {
        userPrompt += `\nAlso include audio narration support for each lesson.`;
      }

      if (revisionPrompt) {
        userPrompt += `\n\n🔁 Revision text: ${revisionPrompt}`;
      }

      userPrompt += `\n\nKeep content professional, practical, and aligned with hospitality training needs. Add 2–3 real, publicly accessible Study Resources that actually exist online. These must be real URLs from credible websites, blogs, or YouTube videos related to hospitality training. Do not invent or fabricate URLs. Prefer resources from well-known educational or industry sites.\n`;

      const typeList = questionTypes.length ? questionTypes.join(', ') : 'Multiple Choice';

      userPrompt += `\n\n🔄 Respond with the entire course content in this exact JSON structure:\n` +
      `{
        "title": "",
        "description": "",
        "objectives": [],
        "lessons": [
          {
            "title": "Lesson Title Here",
            "body": "Fully written paragraphs here totaling approx. 400–500 words, including examples and actionable tips."
          }
        ],
        "questions": [
          {
            "question": "",
            "type": "${typeList}"
            "options": [],
            "answer": ""
          }
        ],
        "resources": [
          "Article: ...",
          "Video: ...",
          "PDF: ..."
        ]
      }`;

      userPrompt += "\n\nRespond ONLY with strict JSON. Use double quotes around all keys and string values. Do not include markdown, explanations, or commentary. Do NOT wrap it in code blocks, markdown syntax, emojis, or any extra characters before or after the JSON. The output must begin with '{' and end with '}'.";

      try {
        const response = await axios.post(
          'https://api.openai.com/v1/chat/completions',
          {
            model: 'gpt-4o-mini',
            temperature: 0.7,
            messages: [
              {
                role: 'system',
                content: `You are a professional instructional designer specialized in creating online training content for ${industry} industry employees.`
              },
              {
                role: 'user',
                content: userPrompt
              }
            ]
          },
          {
            headers: {
              Authorization: `Bearer ${process.env.VUE_APP_OPENAI_API_KEY}`,
              'Content-Type': 'application/json'
            }
          }
        );

        const raw = response.data.choices[0].message.content;
        console.log("Got here");

        if (this.isCancelled) return;

        this.generatedContent = this.parseGeneratedContent(raw);
        this.editableCourseText = this.formatGeneratedContent(this.generatedContent);
        this.showResultsOnly = true;
      } catch (error) {
        console.log('OpenAI Error:', error);
      } finally {
        if (this.isCancelled) return;
        this.progress = 100;
        await new Promise(resolve => setTimeout(resolve, 1000));
        this.loadingAI = false;
      }
    },

    backToPreviousStep() {
      this.showResultsOnly = false;
    },

    backFromCourseType() {
      // Close course type modal and maybe go back to AI modal
      this.showCourseTypeModal = false;

      // Reset modal state
      this.generateAIModal = true;
      this.showResultsOnly = true;
    },

    async onCourseNameBlur() {
      const currentName = this.aiForm.name?.trim();

      if (
        currentName !== this.lastGeneratedName && this.aiForm.name != ""
      ) {
        this.loadingDescription = true;

        try {
          const prompt = `Generate a short two or three sentences, professional, and engaging course description for an e-learning course titled "${currentName}".`;
          const response = await axios.post(
            'https://api.openai.com/v1/chat/completions',
            {
              model: 'gpt-3.5-turbo',
              temperature: 0.7,
              messages: [
                {
                  role: 'system',
                  content: 'You are an expert instructional designer.'
                },
                {
                  role: 'user',
                  content: prompt
                }
              ]
            },
            {
              headers: {
                Authorization: `Bearer ${process.env.VUE_APP_OPENAI_API_KEY}`,
                'Content-Type': 'application/json'
              }
            }
          );

          this.aiForm.description = response.data.choices[0].message.content.trim();
          this.lastGeneratedName = currentName; // Save the used name
        } catch (err) {
          console.error('Error generating course description:', err);
        } finally {
          this.loadingDescription = false;
        }
      }
      else {
        this.aiForm.description = ''
        this.lastGeneratedName = ''
      }
    },

     resetAIForm() {
      this.aiForm = {
        name: '',
        description: '',
        length: null,
        level: '',
        tone: '',
        objectives: '',
        questionCount: 5,
        questionTypes: [],
        includeStockMedia: 'no',
        uploadOwnMedia: 'No',
        uploadedMediaFiles: [],
        accessibility: [],
        stateSpecific: false,
        states: '',
        languages: '',
        revisionPrompt: '',
        courseType: '',
        industry: ''
      };
    },

    submitAICourse() {

      // Show the course type modal
      this.showCourseTypeModal = true;

      // Reset modal state
      this.generateAIModal = false;
      this.showResultsOnly = false;
    },

    async sendCourseByEmail() {
      try {
        console.log(this.aiForm);

        const formData = new FormData();

        formData.append('courseText', this.editableCourseText);
        formData.append('recipient', process.env.VUE_APP_AI_CONTENT_EMAIL);

        // Append other form values from aiForm
        for (const key in this.aiForm) {
          if (key !== 'uploadedMediaFiles') {
            formData.append(key, this.aiForm[key]);
          }
        }

        // Append media files
        this.aiForm.uploadedMediaFiles.forEach((file, index) => {
          formData.append(`media_files[]`, file);
        });
        await this.$http.post('course/ai-course-email', formData, this.config);
        console.log('✅ Email sent!');
        this.showSuccessModal = true;
        this.resetAIForm()

      } catch (err) {
        console.error('❌ Failed to send course email', err);
        Swal.fire({
          title: "Email failed to send!!!",
          text: err,
          icon: "error",
          confirmButtonClass: 'btn btn-success',
          confirmButtonText: 'Ok'
        });
        this.resetAIForm()
      }
    },

    async prefillCourseFields(pdfBlob) {
      const endContent = this.parseFormattedContent(this.editableCourseText)
      console.log(endContent, "End content");
      this.course.course_name = this.aiForm.name
      this.course.course_description = this.aiForm.description
      this.course.course_length = this.aiForm.length
      this.course.course_name_certificate = this.aiForm.name
      this.course.secondary_course_name = this.aiForm.name
      if(this.aiForm.courseType === 'PDF'){
        try {
          const pdfFile = new File([pdfBlob], `${this.aiForm.name}.pdf`, {
            type: 'application/pdf',
            lastModified: new Date().getTime(),
          });
          const url = URL.createObjectURL(pdfBlob)

          this.lesson.lesson_name = this.aiForm.name
          this.lesson.lesson_content = this.aiForm.description
          this.lesson.lesson_type = "pdf"
          this.file = pdfFile
          this.lesson.lesson_pdf_url = url
          this.course.course_lessons.push(this.lesson)
        } catch(err) {
          console.log(err, "Prefilling error");
        }
      }
      try {
        if (endContent.questions && Array.isArray(endContent.questions)) {
          this.test.practice_test = 0;
          this.test.enable_submit_button = true;
          this.test.test_instruction = "Please complete the following questions.";
          this.test.test_pass_message = "Congratulations! You passed the test.";
          this.test.test_fail_message = "Unfortunately, you did not pass. Please try again.";
          this.test.test_no_of_questions = endContent.questions.length;

          this.test.test_questions = endContent.questions.map((q) => {
            const question = {
              question_text: q.question || "",
              question_status: true,
              allowed_attempts: 1,
              options: []
            };

            if (q.type === "True/False") {
              question.options = [
                { option_text: "True", correct: q.answer === "True" },
                { option_text: "False", correct: q.answer === "False" }
              ];
            } else if (q.type === "Multiple Choice") {
              question.options = q.options.map(opt => ({
                option_text: opt,
                correct: opt === q.answer
              }));
            } else if (q.type === "Matching") {
              // Combine matching pairs into question_text
              const formattedOptions = q.options?.length
                ? `\n\nMatching Pairs:\n` + q.options.join('\n')
                : "";

              question.question_text = `${q.question || ""}${formattedOptions}`;

              question.options = [
                {
                  option_text: q.answer,
                  correct: true
                }
              ];
            } else if (q.type === "Fill in the Blank") {
              question.options = [
                {
                  option_text: q.answer,
                  correct: true
                }
              ];
            }

            return question;
          });
          this.course.course_test.push(this.test)
          this.resetAIForm()
        }
      } catch (err) {
        console.log(err, "Error prefilling test");
      }
    },

    async confirmCourseType() {
      if (!this.aiForm.courseType) {
        alert("Please select a course type.");
        return;
      }

      if (this.aiForm.courseType === 'PDF') {
        this.showCourseTypeModal = false;
        this.showPDFLoading = true;
        this.progress = 0;

        this.progressTimer = setInterval(() => {
          if (this.progress < 95) {
            this.progress += 1;
          }
        }, 100);

        // Simulate PDF generation delay
        await new Promise(resolve => setTimeout(resolve, 3000));

        // Finalize progress visually before opening PDF
        clearInterval(this.progressTimer);
        this.progress = 100;

        // Delay modal swap for smoother UX
        setTimeout(() => {
          this.showPDFLoading = false;
          this.showPdfGeneratingModal = false;
          this.generateAndPreviewPDF();
          this.progress = 0;
        }, 1200);



      } else {
        this.showCourseTypeModal = false;
      }
      //Send email
      await this.sendCourseByEmail();
    },

    getMediaUrl(file) {
      return typeof file === 'string' ? file : URL.createObjectURL(file);
    },

    async generateAndPreviewPDF() {
      const content = this.editableCourseText?.trim() ? this.editableCourseText : this.formatGeneratedContent(this.generatedContent);
      const cleanedContent = content.replace(/[^\x00-\x7F]/g, '');

      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4',
      });

      const lineHeight = 8;
      let y = 20;


      if (this.aiForm.uploadedMediaFiles?.length) {
        console.log("There is media");

        const image = this.aiForm.uploadedMediaFiles[0];
        const imageUrl = this.getMediaUrl(image); // define getMediaUrl as shown below

        const logo = new Image();
        logo.src = imageUrl;

        // Wait for the image to load before rendering
        await new Promise((resolve) => {
          logo.onload = () => {
            doc.addImage(logo, 'PNG', 15, 10, 50, 35); // x, y, width, height
            resolve();
          };
        });

        y = 40; // shift content down to make space for image
      }

      const titleMatch = cleanedContent.match(/^Course Title:\s*(.+)$/m);
      const courseTitle = titleMatch ? titleMatch[1].trim() : 'Untitled Course';

      // 2. Remove "Course Title: ..." line from the full content
      const cleanedContentWithoutTitleLine = cleanedContent.replace(/^Course Title:.*\n?/i, '');

      doc.setFontSize(16);
      doc.setFont('helvetica', 'bold');
      doc.text(courseTitle, 105, y, { align: 'center' });


      y += lineHeight + 2;

      // 5. Draw the rest of the content
      doc.setFontSize(11);
      doc.setFont('helvetica', 'normal');

      const lines = doc.splitTextToSize(cleanedContentWithoutTitleLine, 180);
      lines.forEach((line) => {
        if (y > 280) {
          doc.addPage();
          y = 20;
        }
        doc.text(line, 15, y);
        y += 6;
      });

      // Output PDF in new tab
      const pdfBlob = doc.output('blob');
      this.prefillCourseFields(pdfBlob)
      const pdfURL = URL.createObjectURL(pdfBlob);
      window.open(pdfURL, '_blank');

      // Show success modal only
      this.showCourseTypeModal = false;
    },


    setRevision(suggestion) {
      this.aiForm.revisionPrompt = suggestion + ' ';
      this.$nextTick(() => {
        const input = this.$refs.revisionInput;
        if (input) {
          input.focus();
          input.setSelectionRange(input.value.length, input.value.length);
        }
      });
    },

    // onCourseImage(e) {
    //   let files = e;
    //   // if( files[0].type !== "image/png" || files[0].type !== "image/jpeg"){
    //   //     Swal.fire({
    //   //     title: "Error!",
    //   //     text: "Please upload a valid image file (PNG or JPEG).",
    //   //     icon: "error",
    //   //     confirmButtonClass: 'btn btn-success',
    //   //     confirmButtonText: 'Ok'
    //   //   })
    //   //   this.courseImage = null;
    //   //   return;
    //   // }
    //   this.courseImage = files[0];
    //   console.log(this.courseImage);
    // },
    onCourseImage(e) {
  let files = e;
  if (!files.length) return;

  const file = files[0];
  const allowedTypes = ["image/png", "image/jpeg"];

  if (!allowedTypes.includes(file.type)) {
    Swal.fire({
      title: "Error!",
      text: "Please upload a valid image file (PNG or JPEG).",
      icon: "error",
      confirmButtonClass: 'btn btn-success',
      confirmButtonText: 'Ok'
    });
    this.courseImage = null;
    return;
  }

  this.courseImage = file;
  console.log(this.courseImage);
}
,
    //gamification
    openGamificationModel() {
      if (this.lesson.gamified_content.length > 0) {
        for (var i = 1; i < this.lesson.gamified_content.length; i++) {
          document.getElementById("hidegamfication_" + i).classList.add("hide");
        }
      } else {
        this.lesson.gamified_content.push({
          text: "",
        });
      }
      this.gamifiedModel = true;
    },
    closegamification() {
      console.log("Closed");
      this.gamifiedModel = false;
    },
    addAnotherEditor() {
      document.getElementById("hidegamfication_" + this.currindex).classList.remove("show");

      document.getElementById("hidegamfication_" + this.currindex).classList.add("hide");

      this.currindex = this.currindex + 1;
      if (this.currindex >= this.lesson.gamified_content.length) {
        this.lesson.gamified_content.push({
          text: "",
        });
      } else {
        document.getElementById("hidegamfication_" + this.currindex).classList.remove("hide");

        document.getElementById("hidegamfication_" + this.currindex).classList.add("show");

      }

    },
    removeAnotherEditor() {
      if (this.currindex == 0) {
        var id = "hidegamfication_" + parseInt(this.currindex - 2);
        document.getElementById(id).classList.remove("hide");
        document.getElementById(id).classList.add("show");
        var curid = "hidegamfication_" + parseInt(this.currindex - 1);
        document.getElementById(curid).classList.add("hide");
        this.currindex = this.currindex - 1;
      } else {
        var id = "hidegamfication_" + parseInt(this.currindex - 1);
        document.getElementById(id).classList.remove("hide");
        document.getElementById(id).classList.add("show");
        var curid = "hidegamfication_" + parseInt(this.currindex);
        document.getElementById(curid).classList.remove("show");
        document.getElementById(curid).classList.add("hide");
        this.currindex = this.currindex - 1;
      }
    },
    // end gamification
    onImageChange(e) {
      let files = e;
      this.file = files[0];
    },
    validUrl(url) {
      var pattern = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
      if (pattern.test(url)) {
        return true;
      }
      alert("Url is not valid!");
      return false;
    },
    backToTestQuestion() {
      this.test_question = true;
      this.main_test = false;
      this.test_preview = false;
    },
    getTestFile(e) {
      let file = e.target.files || e.dataTransfer.files;
      this.excel_data.file = file[0];
    },
    openTestPreview() {
      if (this.excel_data.file !== "") {
        let formData = new FormData();
        formData.append("questionAnswerFile", this.excel_data.file);
        this.$http
          .post("course/readQuestionAnswer", formData, this.config)
          .then(resp => {
            let data = resp.data.data;
            for (let question of data) {
              let question_obj = {
                question_text: question.question,
                question_status: "",
                options: []
              };
              if (question.status === 1 || question.status === "1") {
                question_obj.question_status = true;
              } else if (question.currect_answer === 0 || question.currect_answer === "0") {
                question_obj.question_status = false;
              }

              for (let option of question.answers) {
                let option_obj = {
                  option_text: option.answer,
                  correct: false,
                };
                if (option.currect_answer === "1" || option.currect_answer === 1) {
                  option_obj.correct = true;
                } else if (option.currect_answer === "0" || option.currect_answer === 0) {
                  option_obj.correct = false;
                }
                question_obj.options.push(option_obj);
              }
              // test_obj.test_questions.push(question_obj);
              this.test.test_questions.push(question_obj);
            }

            this.test_question = false;
            this.main_test = true;
            this.test_preview = false;
          })
          .catch(function (error) {
            if (error.response.status === 422) {
              Swal.fire({
                title: "Error!",
                text: error.response.data.message,
                icon: "error",
                confirmButtonClass: 'btn btn-success',
                confirmButtonText: 'Ok'
              });
            } else {
              Swal.fire({
                title: "Error!",
                text: "Something went wrong.",
                icon: "error",
                confirmButtonClass: 'btn btn-success',
                confirmButtonText: 'Ok'
              });
            }
          });
      } else {
        return Swal.fire({
          title: "Error!",
          text: `Please Select any File!`,
          icon: "error",
          confirmButtonClass: 'btn btn-success',
          confirmButtonText: 'Ok'
        });
      }
    },
    getSurvey() {
      this.$http.get("course/surveytests", this.config).then(resp => {
        this.surveyData = [];
        let obj1 = {
          id: 0,
          survey_name: "Select"
        };
        this.surveyData.push(obj1);
        for (let survey of resp.data) {
          let obj = {
            id: survey.id,
            survey_name: survey.name
          };
          this.surveyData.push(obj);
        }
      });
    },
    backToMainTest() {
      this.test_question = false;
      this.main_test = true;
      this.test_preview = false;
    },
    testQuestionClicked() {
      this.test_question = true;
      this.main_test = false;
      this.test_preview = false;
    },
    getAllFiles: function (e, index) {
      let file = e.target.files || e.dataTransfer.files;
      this.course.course_resources[index].resource_file = file[0];
    },
    openThisTest(test_index) {
      this.updating = true;
      this.testModal = true;
      this.test = this.course.course_test[test_index];
    },

    removeTest(test_index) {
      this.course.course_test.splice(test_index, 1);
    },
    removeLesson(lesson_index) {
      this.course.course_lessons.splice(lesson_index, 1);
    },
    openThisLesson(lesson_index) {
      this.lesson_preview = false;
      this.updating = true;
      this.lessonModal = true;
      this.lesson = this.course.course_lessons[lesson_index];
    },
    backToLesson() {
      this.lesson_preview = false;
    },
    previewLesson() {
      this.lesson_preview = true;
    },

    saveLesson() {
      this.lesson_save_clicked = true;
      this.isRequired = true;
      if (this.lesson.lesson_name !== "" && this.lesson.lesson_content !== "") {
        for (let question of this.lesson.lesson_questions) {
          let correct_answer = false;
          if (question.question_status) {
            this.isRequired = true;
          } else {
            this.isRequired = false;
          }
          if (this.isRequired && this.lesson.quizStatus) {
            if (question.question_text !== "") {
              for (let answer of question.options) {
                if (answer.correct) {
                  correct_answer = true;
                }
                if (answer.option_text === "") {
                  return Swal.fire({
                    title: "Error!",
                    text: `All options's fields are required!`,
                    icon: "error",
                    confirmButtonClass: 'btn btn-success',
                    confirmButtonText: 'Ok'
                  });
                }
              }
              if (!correct_answer) {
                return Swal.fire({
                  title: "Error!",
                  text: `Please select one or multiple correct answers for every question!`,
                  icon: "error",
                  confirmButtonClass: 'btn btn-success',
                  confirmButtonText: 'Ok'
                });
              }
            } else {
              return Swal.fire({
                title: "Error!",
                text: `All Questions's fields are required!`,
                icon: "error",
                confirmButtonClass: 'btn btn-success',
                confirmButtonText: 'Ok'
              });
            }
          }
        }
      } else {
        return Swal.fire({
          title: "Error!",
          text: `All Lesson's Fields are required!`,
          icon: "error",
          confirmButtonClass: 'btn btn-success',
          confirmButtonText: 'Ok'
        });
      }
      this.lessonModal = false;
      this.lesson_preview = false;
      this.lesson_save_clicked = false;
      this.isRequired = true;
      if (!this.updating) {
        this.course.course_lessons.push(this.lesson);
      }
    },
    saveTest() {
      this.test_save_clicked = true;
      this.isRequired = true;
      if (
        this.test.test_fail_message !== "" &&
        this.test.test_instruction !== "" &&
        this.test.test_pass_message !== ""
      ) {
        for (let question of this.test.test_questions) {
          let correct_answer = false;
          if (question.question_status) {
            this.isRequired = true;
          } else {
            this.isRequired = false;
          }
          if (this.isRequired) {
            if (question.question_text !== "") {
              for (let answer of question.options) {
                if (answer.correct) {
                  correct_answer = true;
                }
                if (answer.option_text === "") {
                  return Swal.fire({
                    title: "Error!",
                    text: `All options's fields are required!`,
                    icon: "error",
                    confirmButtonClass: 'btn btn-success',
                    confirmButtonText: 'Ok'
                  });
                }
              }
              if (!correct_answer) {
                return Swal.fire({
                  title: "Error!",
                  text: `Please select one or multiple correct answers for every question!`,
                  icon: "error",
                  confirmButtonClass: 'btn btn-success',
                  confirmButtonText: 'Ok'
                });
              }
            } else {
              return Swal.fire({
                title: "Error!",
                text: `All Questions's fields are required!`,
                icon: "error",
                confirmButtonClass: 'btn btn-success',
                confirmButtonText: 'Ok'
              });
            }
          }
        }
      } else {
        return Swal.fire({
          title: "Error!",
          text: `All Test's Fields are required!`,
          icon: "error",
          confirmButtonClass: 'btn btn-success',
          confirmButtonText: 'Ok'
        });
      }
      this.test_question = false;
      this.main_test = true;
      this.test_preview = false;
      this.testModal = false;
      this.test_save_clicked = false;

      if (!this.updating) {
        this.course.course_test.push(this.test);
      }
    },
    saveCertificates() {
      if (
        this.certificate.certificate_name !== "" &&
        this.certificate.certificate_signature_title_1
      ) {
        this.$http
          .post(
            "course/certificate",
            {
              course_certificate_name: this.certificate.certificate_name,
              course_certificate_valid: this.certificate.certificate_valid_time,
              course_certificate_custom_text: this.certificate
                .certificate_custom_text,
              signature_title_1: this.certificate.certificate_signature_title_1,
              signature_title_2: this.certificate.certificate_signature_title_2
            },
            this.config
          )
          .then(resp => {
            Swal.fire({
              title: "Success!",
              text: `Certificate Added! Now You can select this certificate from Dropdown`,
              icon: "success",
              confirmButtonClass: 'btn btn-success',
              confirmButtonText: 'Ok'
            });
          });
      } else {
        return Swal.fire({
          title: "Error!",
          text: `All fields are required!`,
          icon: "error",
          confirmButtonClass: 'btn btn-success',
          confirmButtonText: 'Ok'
        });
      }
    },
    addTestClicked() {
      this.test_question = false;
      this.main_test = true;
      this.test_preview = false;
      this.updating = false;
      this.testModal = true;
      this.test = {
        practice_test: 0,
        enable_submit_button: "",
        test_instruction: "",
        test_pass_message: "",
        test_fail_message: "",
        test_no_of_questions: "",
        test_questions: [
          {
            question_text: "",
            question_status: true,
            allowed_attempts: "",
            options: [
              {
                option_text: "",
                correct: false
              }
            ]
          }
        ]
      };
    },
    deleteCourse() {
      let self = this;
      Swal.fire({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn",
        cancelButtonClass: "btn greybtn",
        confirmButtonColor: "#E0E0E0",
        cancelButtonColor: "",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No",
        // buttonsStyling: false
      })
        .then(function () {
          Swal.fire({
            title: "Deleted!",
            text: "Your file has been deleted.",
            icon: "success",
            confirmButtonClass: "btn btn-success",
            // buttonsStyling: false
          }).then(function () {
            self.$router.push({
              path: "/courses"
            });
          });
        })
        .catch(function () {
        });
    },

    saveCourse() {
      this.processing = true;
      this.loading = true;
      if (
        this.course.course_name !== "" &&
        this.course.course_description !== "" &&
        // this.course.course_cost !== "" &&
        this.course.status !== "" &&
        this.course.live !== "" &&

        this.course.allowed_attempts !== ""
      ) {
        const config = {
          headers: {
            "content-type": "multipart/form-data"
          }
        };
        let formData = new FormData();
        formData.append("course_name", this.course.course_name);
        formData.append("secondary_course_name", this.course.secondary_course_name)
        formData.append('image', this.courseImage);
        formData.append(
          "course_name_certificate",
          this.course.course_name_certificate
        );
        formData.append("course_length", this.course.course_length);
        formData.append("course_pass_rate", this.course.course_pass_rate);
        formData.append("nextcourse", this.course.nextcourse);
        if (this.course.companyspecific) {
          formData.append("companyspecific", this.course.companyspecific);
        }
        let fm = 0;
        let fe = 0;
        fm = this.course.formanager ? 1 : 0;
        fe = this.course.foremployee ? 1 : 0;
        formData.append("formanager", fm);
        formData.append("foremployee", fe);
        formData.append(
          "employees_days_to_complete",
          this.course.employees_days_to_complete
        );
        formData.append(
          "manager_days_to_complete",
          this.course.manager_days_to_complete
        );
        let re = 0;
        re = this.course.reassignment_expiry ? 1 : 0;
        formData.append("reassignment_expiry", re);
        formData.append("expiry_attempts", this.course.expiry_attempts);
        formData.append(
          "certificate_validity",
          this.course.certificate_validity
        );
        let ca = 0;
        let ct = 0;
        let c2 = 0;
        let dc = 0;
        let wr = 0;
        let food_safe_online_proctored_exam_form_data = 0;
        ca = this.course.certificateavilable ? 1 : 0;
        ct = this.course.course_type ? 1 : 0;
        c2 = this.course.course_2fa ? 1 : 0;
        dc = this.course.discounted_course ? 1 : 0;
        wr = this.course.weekly_report ? 1 : 0;
        food_safe_online_proctored_exam_form_data = this.course
          .food_safe_online_proctored_exam
          ? 1
          : 0;
        formData.append("assignment_gap", this.course.assignment_gap);
        formData.append("certificateavilable", ca);
        formData.append("course_allow_attempts", this.course.allowed_attempts);
        formData.append("course_cost", this.course.course_cost);
        formData.append("pass_message", this.course.course_passmessage);
        formData.append("fail_message", this.course.course_failmessage);
        //formData.append('course_due', this.course.course_due);
        formData.append("course_description", this.course.course_description);
        formData.append("course_type", ct);
        formData.append("course_2fa", c2);
        formData.append("discounted_course", dc);
        formData.append("weekly_report", wr);
        formData.append(
          "food_safe_online_proctored_exam",
          food_safe_online_proctored_exam_form_data
        );
        formData.append("courseResources", this.course.courseResources);
        formData.append(
          "discounted_course_comment",
          this.course.discounted_course_comment
        );
        formData.append("weekly_report", wr);
        let st = 0;
        let liv = 0;
        let pop = 0;
        let hr = 0;
        st = this.course.status ? 1 : 0;
        liv = this.course.live ? 1 : 0;
        pop = this.course.popular ? 1 : 0;
        hr = this.course.hrbasics ? 1 : 0;

        formData.append("is_hrbasics", hr);
        formData.append("course_popular", pop);
        formData.append("course_status", st);
        formData.append("course_in_store", liv);
        formData.append("course_classification", this.course.classification || "");

        if (this.course.course_lessons.length <= 0 && !this.course.isScorm) {
          this.loading = false;
          this.processing = false;
          this.saving = false;
          return Swal.fire({
            title: "Error!",
            text: `At least One Lesson is Required!`,
            icon: "error",
            confirmButtonClass: 'btn btn-success',
            confirmButtonText: 'Ok'
          });
        } else {
          let i = 0;
          for (let lesson of this.course.course_lessons) {
            formData.append(
              "lessons[" + i + "][course_lesson_name]",
              lesson.lesson_name
            );
            let nbt = 0;

            nbt = lesson.nextButtonTimerStatus ? 1 : 0;

            formData.append(
              "lessons[" + i + "][course_next_button_timer_status]",

              nbt
            );

            formData.append(
              "lessons[" + i + "][course_timer_value]",

              lesson.timerValue
            );

            formData.append(
              "lessons[" + i + "][allowed_attempts]",
              lesson.allowed_attempts
            );
            formData.append(
              "lessons[" + i + "][course_passmessage]",
              lesson.course_passmessage
            );
            formData.append("lessons[" + i + "][type]", lesson.lesson_type);
            if (lesson.lesson_type == "video") {
              formData.append(
                "lessons[" + i + "][course_lesson_video]",
                "https://player.vimeo.com/video/" + lesson.lesson_video_url
              );
            }
            if (lesson.lesson_type == "youtube-video") {
              formData.append(
                "lessons[" + i + "][course_lesson_video]",
                "https://www.youtube.com/embed/" +
                lesson.youtube_lesson_video_url
              );
            }
            if (lesson.lesson_type == "pdf" && this.file != undefined) {
              if (this.file) {
                formData.append(
                  "lessons[" + i + "][course_lesson_pdf]",
                  this.file
                );
              } else if (!lesson.lesson_video_url) {
                formData.append(
                  "lessons[" + i + "][course_lesson_pdf]",
                  lesson.lesson_pdf_url
                );
              }
            }
            if (lesson.lesson_type == "gamification") {
              let l = 0;
              for (let content of this.lesson.gamified_content) {
                if (content.text) {
                  formData.append(
                    "lessons[" + i + "][course_lesson_gamification][" + l + "]",
                    content.text
                  );
                }
                l++;
              }
            }

            formData.append(
              "lessons[" + i + "][course_lesson_content]",
              lesson.lesson_content
            );
            formData.append(
              "lessons[" + i + "][course_lesson_quiz]",
              lesson.lesson_quiz_instruction
            );

            let qs = 0;

            qs = lesson.quizStatus ? 1 : 0;
            formData.append("lessons[" + i + "][quizStatus]", qs);

            formData.append(
              "lessons[" + i + "][passing_rate]",
              lesson.passing_rate
            );
            formData.append(
              "lessons[" + i + "][no_of_questions]",
              lesson.no_of_questions
            );
            let j = 0;
            for (let question of lesson.lesson_questions) {
              formData.append(
                "lessons[" + i + "][questions][" + j + "][question]",
                question.question_text
              );
              formData.append(
                "lessons[" + i + "][questions][" + j + "][status]",
                question.question_status
              );
              let k = 0;
              for (let answer of question.options) {
                formData.append(
                  "lessons[" +
                  i +
                  "][questions][" +
                  j +
                  "][answers][" +
                  k +
                  "][course_quiz_question_option]",
                  answer.option_text
                );
                let ans = 0;
                if (answer.correct) {
                  ans = 1;
                } else {
                  ans = 0;
                }
                formData.append(
                  "lessons[" +
                  i +
                  "][questions][" +
                  j +
                  "][answers][" +
                  k +
                  "][course_quiz_correct_answer]",
                  ans
                );
                k++;
              }
              j++;
            }
            i++;
          }
        }
        let i = 0;
        for (let test of this.course.course_test) {
          formData.append(
            "tests[" + i + "][practice_test]",
            test.practice_test
          );
          formData.append(
            "tests[" + i + "][enable_submit_button]",
            test.enable_submit_button
          );
          formData.append(
            "tests[" + i + "][course_test_instruction]",
            test.test_instruction
          );
          formData.append(
            "tests[" + i + "][course_test_pass_msg]",
            test.test_pass_message
          );
          formData.append(
            "tests[" + i + "][course_test_fail_msg]",
            test.test_fail_message
          );
          formData.append(
            "tests[" + i + "][course_no_of_questions]",
            test.test_no_of_questions
          );
          let j = 0;
          for (let question of test.test_questions) {
            formData.append(
              "tests[" + i + "][questions][" + j + "][question]",
              question.question_text
            );
            formData.append(
              "tests[" + i + "][questions][" + j + "][status]",
              question.question_status
            );
            let k = 0;
            for (let answer of question.options) {
              formData.append(
                "tests[" +
                i +
                "][questions][" +
                j +
                "][answers][" +
                k +
                "][course_quiz_question_option]",
                answer.option_text
              );
              let ans = 0;
              ans = answer.correct ? 1 : 0;

              formData.append(
                "tests[" +
                i +
                "][questions][" +
                j +
                "][answers][" +
                k +
                "][course_quiz_correct_answer]",
                ans
              );
              k++;
            }
            j++;
          }
          i++;
        }
        i = 0;
        for (let pretest of this.course.course_pretest) {
          formData.append("pretests[" + i + "][name]", pretest.name);
          formData.append(
            "pretests[" + i + "][instructions]",
            pretest.instructions
          );
          let j = 0;
          for (let question of pretest.pretest_questions) {
            formData.append(
              "pretests[" + i + "][pretest_questions][" + j + "][question]",
              question.question
            );
            formData.append(
              "pretests[" +
              i +
              "][pretest_questions][" +
              j +
              "][is_update_employee]",
              question.is_update_employee
            );
            formData.append(
              "pretests[" + i + "][pretest_questions][" + j + "][answer_type]",
              question.answer_type
            );
            formData.append(
              "pretests[" +
              i +
              "][pretest_questions][" +
              j +
              "][question_status]",
              question.question_status
            );
            formData.append(
              "pretests[" +
              i +
              "][pretest_questions][" +
              j +
              "][checked_validations]",
              question.checked_validations
            );
            let k = 0;
            for (let answer of question.answers) {
              formData.append(
                "pretests[" +
                i +
                "][pretest_questions][" +
                j +
                "][answers][" +
                k +
                "][answer]",
                answer.answer
              );
              k++;
            }
            j++;
          }
          i++;
        }

        if (this.course.assigned_companies_id.length > 0) {
          i = 0;
          for (let company_id of this.course.assigned_companies_id) {
            formData.append("companies[" + i + "][id]", company_id);
            i++;
          }
        }
        if (this.course.course_certificate != "") {
          formData.append("certificate_ids", this.course.course_certificate);
        }
        if (this.course.course_survey !== "") {
          i = 0;
          formData.append(
            "survey_ids[" + i + "][id]",
            this.course.course_survey
          );
        }

        formData.append("isScorm", this.course.isScorm);

        if (this.course.isScorm) {
          formData.append("scormFile", this.course.scormFile);
          formData.append("scorm_version", this.course.scorm_version);
        }

        if(this.company_id!=''){
          formData.append("companyName",this.company_name);
        }

        // Axios configuration with progress tracking
        const axiosConfig = {
          headers: {
            Authorization: "Bearer " + this.hot_token,
            "Content-Type": "multipart/form-data"
          },
          onUploadProgress: (progressEvent) => {
            if (this.course.isScorm && this.course.scormFile) {
              this.showProgress = true;
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              this.progress = percentCompleted;
            }
          }
        };

        axios
        .post(this.$baseUrl + "/course", formData, axiosConfig)
          .then(resp => {
            this.$router.push("courses");
            Swal.fire({
              title: "Success!",
              text: `Course has been added!`,
              icon: "success",
              confirmButtonClass: 'btn btn-success',
              confirmButtonText: 'Ok'
            });
          })
          .catch(function (error) {
            if (error.response.status === 422) {
              Swal.fire({
                title: "Error!",
                text: error.response.data.message,
                icon: "error",
                confirmButtonClass: 'btn btn-success',
                confirmButtonText: 'Ok'
              });
            } else {
              Swal.fire({
                title: "Error!",
                text: "Something went wrong.",
                icon: "error",
                confirmButtonClass: 'btn btn-success',
                confirmButtonText: 'Ok'
              });
            }
          })
          .finally(() => (this.loading = false));
      } else {
        this.loading = false;
        this.processing = false;
        this.saving = false;
        let requiredFeilds = "";
        if (this.course.course_name == "") {
          requiredFeilds = "Course Name";
        }

        if (this.course.course_description == "") {
          if (requiredFeilds == "") {
            requiredFeilds = "Description";
          } else {
            requiredFeilds += ", Description";
          }
        }
        // if (this.course.course_cost == "") {
        //     if (requiredFeilds == "") {
        //         requiredFeilds = "Cost";
        //     } else {
        //         requiredFeilds += ", Cost";
        //     }
        // }


        if (this.course.allowed_attempts == "") {
          if (requiredFeilds == "") {
            requiredFeilds = "Allowed Attempts";
          } else {
            requiredFeilds += ", Allowed Attempts";
          }
        }
        Swal.fire({
          title: "Following field(s) are required!",
          text: requiredFeilds,
          icon: "error",
          confirmButtonClass: 'btn btn-success',
          confirmButtonText: 'Ok'
        });
      }
    },
    addFile() {
    },
    addOptionTest(question_index) {
      this.test.test_questions[question_index].options.push({
        option_text: "",
        correct: false
      });
    },
    addQuestiontest() {
      this.test.test_questions.push({
        question_text: "",
        question_status: true,
        allowed_attempts: "",
        options: [
          {
            option_text: "",
            correct: false
          }
        ]
      });
    },

    addOptionlesson(question_index) {
      this.lesson.lesson_questions[question_index].options.push({
        option_text: "",
        correct: false
      });
    },
    removeTestQuestion(index) {
      this.test.test_questions.splice(index, 1);
    },
    removeTestOption(q_index, opt_index) {
      this.test.test_questions[q_index].options.splice(opt_index, 1);
    },
    removeLessonOption(q_index, opt_index) {
      this.lesson.lesson_questions[q_index].options.splice(opt_index, 1);
    },
    removeLessonQuestion(index) {
      this.lesson.lesson_questions.splice(index, 1);
    },
    addQuestionlesson() {
      this.lesson.lesson_questions.push({
        question_text: "",
        question_status: true,
        allowed_attempts: "",
        options: [
          {
            option_text: "",
            correct: false
          }
        ]
      });
    },
    addCertificateClicked() {
      this.certificateModal = true;
      this.certificate = {
        certificate_name: "",
        course_id: "",
        certificate_date: "",
        certificate_valid_time: "",
        certificate_custom_text: ""
      };
    },
    addLessonClicked() {
      this.lesson_preview = false;
      this.updating = false;
      this.lessonModal = true;
      this.lesson = {
        lesson_name: "",
        lesson_video_url: "",
        gamified_content: [
          {
            text: "",
          },
        ],
        nextButtonTimerStatus: false,
        timerValue: "",
        allowed_attempts: "",
        lesson_content: "",
        lesson_quiz_instruction: "",
        lesson_questions: [
          {
            question_text: "",
            question_status: true,
            allowed_attempts: "",
            options: [
              {
                option_text: "",
                correct: false
              }
            ]
          }
        ]
      };
    },
    addNewResource() {
      this.course.course_resources.push({
        resource_name: "",
        resource_type: "",
        resource_url: "",
        resource_file: ""
      });
    },
    removeNewResource(resource_index) {
      this.course.course_resources.splice(resource_index, 1);
    },
    // PreTestVue
    acceptNumber() {
      var x = this.previewPhone
        .replace(/\D/g, "")
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      this.previewPhone = !x[2]
        ? x[1]
        : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
    },
    addQuestionpretest() {
      this.pretestQuizModal = true;
    },
    removePreTest(test_index) {
      this.course.course_pretest.splice(test_index, 1);
    },
    addPreTestClicked() {
      this.pretestModal = true;
    },
    addPreOptionTest(question_index) {
      this.pretest.pretest_questions[question_index].answers.push({
        answer: "",
        correct_answer: false
      });
    },
    addQuestionPretest() {
      this.pretest.pretest_questions.push({
        question: "",
        is_update_employee: "",
        question_status: true,
        answer_type: "",
        checked_validations: "",
        answers: [
          {
            answer: "",
            correct_answer: false
          }
        ]
      });
    },
    openThisPreTest(test_index) {
      this.updating = true;
      this.pretestModal = true;
      this.pretest = this.course.course_pretest[test_index];
    },
    savePreTest() {
      this.pretest_save_clicked = true;
      this.isRequired = true;
      if (this.pretest.name !== "" && this.pretest.instructions !== "") {
        for (let question of this.pretest.pretest_questions) {
          let correct_answer = false;
          if (question.question_status && question.answer_type == "2") {
            this.isRequired = true;
          } else {
            this.isRequired = false;
          }
          if (this.isRequired) {
            if (question.question !== "") {
              for (let answer of question.answers) {
                if (answer.answer === "") {
                  return Swal.fire({
                    title: "Error!",
                    text: `All options's fields are required!`,
                    icon: "error",
                    confirmButtonClass: 'btn btn-success',
                    confirmButtonText: 'Ok'
                  });
                }
              }
            } else {
              return Swal.fire({
                title: "Error!",
                text: `All Questions's fields are required!`,
                icon: "error",
                confirmButtonClass: 'btn btn-success',
                confirmButtonText: 'Ok'
              });
            }
          }
        }
      } else {
        return Swal.fire({
          title: "Error!",
          text: `All Test's Fields are required!`,
          icon: "error",
          confirmButtonClass: 'btn btn-success',
          confirmButtonText: 'Ok'
        });
      }
      this.pretest_question = false;
      this.main_test = true;
      this.test_preview = false;
      this.pretestModal = false;
      this.test_save_clicked = false;
      if (!this.updating) {
        this.course.course_pretest.push(this.pretest);
      }
    },
    removePreTestQuestion(index) {
      this.pretest.pretest_questions.splice(index, 1);
    },
    removePreTestOption(q_index, opt_index) {
      this.pretest.pretest_questions[q_index].answers.splice(opt_index, 1);
    },
    // Survey Test

    addQuestionsurveytest() {
      this.surveytestQuizModal = true;
    },
    removeSurveyTest(test_index) {
      this.course.course_surveytest.splice(test_index, 1);
    },
    addSurveyTestClicked() {
      this.surveytestModal = true;
    },
    addSurveyOptionTest(question_index) {
      this.surveytest.surveytest_questions[question_index].answers.push({
        answer: "",
        correct_answer: false
      });
    },
    addQuestionSurveytest() {
      this.surveytest.surveytest_questions.push({
        question: "",
        question_status: true,
        answer_type: "",
        checked_validations: "",
        answers: [
          {
            answer: "",
            correct_answer: false
          }
        ]
      });
    },
    openThisSurveyTest(test_index) {
      this.updating = true;
      this.surveytestModal = true;
      this.surveytest = this.course.course_surveytest[test_index];
    },
    saveSurveyTest() {
      this.surveytest_save_clicked = true;
      this.isRequired = true;
      if (this.surveytest.name !== "" && this.surveytest.instructions !== "") {
        for (let question of this.surveytest.surveytest_questions) {
          let correct_answer = false;
          if (question.question_status && question.answer_type == "2") {
            this.isRequired = true;
          } else {
            this.isRequired = false;
          }
          if (this.isRequired) {
            if (question.question !== "") {
              for (let answer of question.answers) {
                if (answer.answer === "") {
                  return Swal.fire({
                    title: "Error!",
                    text: `All options's fields are required!`,
                    icon: "error",
                    confirmButtonClass: 'btn btn-success',
                    confirmButtonText: 'Ok'
                  });
                }
              }
            } else {
              return Swal.fire({
                title: "Error!",
                text: `All Questions's fields are required!`,
                icon: "error",
                confirmButtonClass: 'btn btn-success',
                confirmButtonText: 'Ok'
              });
            }
          }
        }
      } else {
        return Swal.fire({
          title: "Error!",
          text: `All Test's Fields are required!`,
          icon: "error",
          confirmButtonClass: 'btn btn-success',
          confirmButtonText: 'Ok'
        });
      }

      this.$http
        .post("course/createSurvey", this.surveytest, this.config)
        .then(resp => {
          this.surveytest_question = false;
          this.getSurvey();
          this.main_test = true;
          this.surveytestModal = false;
          this.surveytest_save_clicked = false;
          Swal.fire({
            title: "Success!",
            html:
              "Survey added successfully.</br>You can select it from dropdown.",
            icon: "success",
            confirmButtonClass: 'btn btn-success',
            confirmButtonText: 'Ok'
          });
        });
    },
    removeSurveyTestQuestion(index) {
      this.surveytest.surveytest_questions.splice(index, 1);
    },
    removeSurveyTestOption(q_index, opt_index) {
      this.surveytest.surveytest_questions[q_index].answers.splice(
        opt_index,
        1
      );
    },
    handleScromFile: function (event) {
      this.course.scormFile = event.target.files[0];
    }
  }
};
</script>
<style>
.modal-select-dropdown.el-select-dropdown.el-popper {
  z-index: 10001 !important; /* higher than .modal-backdrop (9999) */
}
</style>
<style scoped>

.editable-input {
  width: 100%;
  padding: 0.3rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
  margin-bottom: 0.5rem;
}

.resource-item {
  margin-bottom: 1rem;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  width: 100%;
  max-width: 1000px;
  max-height: 90vh; /* important */
  overflow-y: auto;  /* adds scroll when needed */
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
  font-family: 'Helvetica Neue', sans-serif;
}

.modal-content h3 {
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  text-align: center;
  color: #333;
}

.modal-content label {
  display: block;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #444;
}

.modal-content label.required::after {
  content: ' *';
  color: red;
}

textarea::placeholder {
  font-size: 15px;
  color: #C0C4CC;
}

input::placeholder {
  font-size: 15px;
  color: #C0C4CC;
}

input[type="text"],
input[type="number"] {
  height: 45px;
  width: 100%;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 0 12px;
  box-sizing: border-box;
  margin-bottom: 25px;
}
.modal-content textarea {
  width: 100%;
  border-radius: 4px;
  padding: 0 12px;
  border: 1px solid #dcdfe6;
  margin-bottom: 25px;
}
.modal-content select {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 1rem;
  margin-bottom: 1.5rem;
  transition: border-color 0.3s;
}

.modal-content input:focus,
.modal-content textarea:focus,
.modal-content select:focus {
  border-color: #f45b26;
  outline: none;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.modal-actions .btn-submit {
  background-color: #f45b26;
  color: white;
  font-weight: bold;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  cursor: pointer;
}

.modal-actions .btn-cancel {
  background-color: #ccc;
  color: #333;
  font-weight: bold;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  cursor: pointer;
}

.large-pdf-preview {
  max-width: 1000px;
  max-height: 90vh;
  overflow-y: auto;
  padding: 2rem;
}

.modal-box {
  position: relative;
  background: white;
  padding: 2rem 3rem;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  text-align: center;
  max-width: 600px;
  width: 90%;
}

.btn-secondary {
    background-color: #555;
  color: white;
  font-weight: bold;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.btn-secondary:hover {
  background-color: #333;
}

.pdf-content {
  text-align: left;
  font-size: 14px;
  line-height: 1.6;
}

.progress-bar {
  width: 100%;
  height: 20px;
  background-color: #f0f0f0;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: inset 0 0 5px #ccc;
}

.loading-overlay {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99999;
  background: rgba(0, 0, 0, 0.5);
  width: 150vw;
  height: 120vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-box {
  background: white;
  padding: 3rem 4rem;
  border-radius: 16px;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.2);
  text-align: center;
  width: 95%;
  max-width: 600px; /* Larger max width */
  transform: scale(1.1); /* Optional zoom effect */
}

.loading-box p {
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 1.5rem;
}

.progress-bar-container {
  width: 100%;
  height: 28px; /* Increased height */
  background-color: #f0f0f0;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: inset 0 0 6px #ccc;
}

.progress-bar-fill {
  height: 100%;
  border-radius: 14px;
  transition: width 1s ease;
  background: linear-gradient(270deg, #e59139, #ea2a29, #ea6629);
  background-size: 600% 600%;
  animation: glow 2s linear infinite;
  box-shadow: 0 0 12px rgba(234, 42, 41, 0.6),
              0 0 24px rgba(234, 102, 41, 0.4),
              0 0 36px rgba(229, 145, 57, 0.2);
}

@keyframes glow {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

input[type="file"] {
  margin-bottom: 0.25rem; /* reduce bottom space if needed */
}

.custom-select-container {
  position: relative;
  width: 100%;
  font-size: 16px;
  font-family: 'Helvetica Neue', sans-serif;
  margin-bottom: 2rem;
}

.custom-select-box {
  background: white;
  border: 1px solid #dcdfe2;
  border-radius: 6px;
  padding: 10px 12px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #606266;
}

.custom-select-box:hover {
  border-color: #c0c4cc;
}

.arrow {
  font-size: 12px;
  margin-left: 10px;
}

.custom-select-options {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  margin-top: 4px;
  background: white;
  border-radius: 6px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid #ebeef5;
  list-style: none;
  padding: 4px 0;
  z-index: 9999;
}

.custom-select-options li {
  padding: 10px 16px;
  cursor: pointer;
  color: #606266;
}

.custom-select-options li:hover {
  background-color: #f5f7fa;
}

.custom-select-options li.selected {
  background-color: #ecf5ff;
  font-weight: 600;
}


/* AI styles end */

.scroll-box {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ddd;
  padding: 1rem;
  border-radius: 8px;
  background: #f9f9f9;
  margin-bottom: 2rem;
}

.objective-block {
  margin-bottom: 1rem;
}

.lesson-block {
  margin-bottom: 1.25rem;
}

.editable-input.lesson-title {
  font-weight: bold;
  font-size: 1.1rem;
  margin-bottom: 0.3rem;
}

.brand-logo-preview {
  max-height: 80px;
  max-width: 200px;
  margin-bottom: 1rem;
  display: block;
}

.advanced-options input,
.advanced-options select {
  width: 100%;
  margin-bottom: 1rem;
}
.suggestion {
  background-color: #f2f2f2;
  border: none;
  padding: 8px 14px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  transition: background-color 0.2s;
}

.suggestion:hover {
  background-color: #e0e0e0;
}
.checkbox-row {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.checkbox-row input[type="checkbox"] {
  margin: 0;
  transform: scale(1);
}

.question-option {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.correct-check {
  color: green;
  font-weight: bold;
  white-space: nowrap;
}

.form-select {
  width: 100%;
  padding: 8px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 14px;
}

.block-label {
  display: block;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.question-types-grid {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-width: 400px; /* Optional: controls width */
}

.question-type-row {
  display: grid;
  grid-template-columns: 1fr auto;
  column-gap: 0.25rem;
  align-items: center;
}

.question-type-text {
  white-space: nowrap;
  font-weight: 400;
  align-self: center;
}

.question-checkbox {
  justify-self: start;
  align-self: center;
}

.success-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.success-content {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  width: 60%;              /* or even 400px if you prefer fixed size */
  max-width: 500px;
  box-shadow: 0 0 10px rgba(0,0,0,0.2);
  text-align: center;
}

.btn-submit-success {
  background-color: #f45d22;
  color: white;
  padding: 0.5rem 1.5rem;
  font-weight: bold;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.btn-submit-success:hover {
  background-color: #d94e1b;
}

.scroll-box textarea.editable-textarea {
  min-height: 600px;
  white-space: pre-wrap;
  overflow-y: auto;
  font-weight: 500;
}



/* Progress bar styling */
.el-progress {
  margin-bottom: 20px;
}

.el-progress__text {
  font-size: 14px;
  color: #606266;
}

/* Thicker progress bar with rounded corners and orange color */
.el-progress-bar__outer {
  height: 12px !important; /* Thicker bar */
  border-radius: 6px; /* Normal rounded corners */
  background-color: #f5f5f5; /* Light gray background for unfilled portion */
}

.el-progress-bar__inner {
  background-color: #f28c38; /* Orange color */
  border-radius: 6px; /* Match outer border-radius for smooth look */
}
.stripe-card {
  border: 1px solid grey;
}

.stripe-card.complete {
  border-color: green;
}

.logo-size {
  width: 60%;
  height: auto;
}

hr {
  border-top: 1px solid #f2f2f2 !important;
  margin-top: 12px;
  margin-bottom: 12px;
}

.border-right {
  border-right: 1px solid darkblue;
}

.ql-editor {
  border: none;
  border-top: 1px solid #cccccc;
}

.que-box-titel {
  border-bottom: 1px solid red;
}

.que-ans-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}

.currest-ans-label {
  position: absolute;
  right: 16%;
  left: 67%;
  width: 100px;
}

.custom-checkbox .custom-control-input:checked~.custom-control-label::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e") !important;
}

.modal-header {
  align-items: center !important;
}

.hide {
  display: none;
}

.show {
  display: block;
}
.progress-bar-wrap >>> .el-progress-bar__outer {
  height:17px !important;
border-radius: 4px;

}
.progress-bar-wrap >>> .el-progress-bar__inner {
text-align: center;
border-radius: 4px;

}
.progress-bar-wrap.is-success >>> .el-progress-bar__inner {
  background-color:  #fe672c ;
}

/* Checkbox labels (Practice test, Correct Answer) – font-weight only in this file */
.modal-content label {
  font-weight: 400 !important;
}
</style>
